import { DOCUMENT } from '@angular/common';
import {
  Component,
  effect,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  CommonModels,
  ErrorModels,
  HealthModels,
  PolicyModels,
  QuotationModels,
} from '@wz-models';
import { FileService, LoadingService, LoggerService } from '@wz-services';
import { AutoUnsubscribeComponent } from '@wz-utilities/auto-unsubscribe.component';
import { objectToArray } from '@wz-utilities/object.utilities';
import * as CryptoJS from 'crypto-js';
import * as $ from 'jquery';
import { DocumentTabService } from 'libs/modules/tunnelsante/services/document-tab.service';
import { HealthInsuranceService } from 'libs/modules/tunnelsante/services/health-insurance.service';
import { HealthQuotationService } from 'libs/modules/tunnelsante/services/health-quotation.service';
import { InteractionService } from 'libs/modules/tunnelsante/services/interaction.service';
import { DateTime } from 'luxon';
import { HttpModels } from 'models/api/http.models';
import { TextGarantieCegemaEquilibre } from 'models/text-garantie-cegema-equilibre.model';
import { TextGarantieCegemaFlexibiliteNR } from 'models/text-garantie-cegema-flexibilite-nr.model';
import { TextGarantieCegemaFlexibilite100Sante } from 'models/text-garantie-cegema-flexibilite-sante.model';
import { TextGarantiekereisSereniteSante } from 'models/text-garantie-cegema-serenite-sante.model';
import { TextGarantieModelSpvie } from 'models/text-garantie-model-spvie.model';
import { TextGarantieModelZenioo } from 'models/text-garantie-model-zenioo.model';
import {
  NiveauxGarantieMtxVita55Plus,
  NiveauxGarantieMtxVitaFamille,
  TextGarantieMtxVita,
} from 'models/text-garantie-mtx-vita.model';
import { TexteGarantiesModels } from 'models/texte-garanties.models';
import { merge, Subject, Subscription } from 'rxjs';
import { debounceTime, finalize, takeUntil } from 'rxjs/operators';
import { Personne } from '../devis-formulaire/Models/Personne';
import { Question } from '../health-quotation-formB2C/factory-age-validators';
import { MyDataService } from '../services/my-data.service';
import { TaggingService } from '../services/tagging.service';
import { DemanderDevisDialogComponent } from './demander-devis-dialog/demander-devis-dialog.component';
import { EtreRappeleDialogComponent } from './etre-rappele-dialog/etre-rappele-dialog.component';

@Component({
  selector: 'wz-formula-pickerB2C',
  templateUrl: './formula-picker.component.html',
  styleUrls: ['./formula-picker.component.scss'],
  standalone: false,
})
export class FormulaPickerB2CComponent
  extends AutoUnsubscribeComponent
  implements OnInit, OnChanges
{
  FormulaEnum = QuotationModels.FormulaEnum;
  PackageEnum = PolicyModels.PackageEnum;
  InsuranceTypeEnum = CommonModels.InsuranceTypeEnum;
  accordionDisplay = false;
  metas!: HealthModels.HealthPolicyPricingMetadatas;

  docName = {
    CG: QuotationModels.DocType.CG,
    TG: QuotationModels.DocType.TG,
    FID: QuotationModels.DocType.FID,
  };

  @Input()
  formulesAfi!: QuotationModels.ReponseAfiExport[];

  isMobile: boolean = false;

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: Event) {
    // Code to execute on window resize
    this.correctInfobuleWidth();
    // Add your custom logic here
  }

  receipFiltrePrix(event: any) {
    if (event === 'croissant') {
      this.formulesAfi[0]?.tarifs?.sort((n1: any, n2: any) => {
        var n1N = +this.ate(n1.montant);
        var n2N = +this.ate(n2.montant);
        return n1N - n2N;
      });
    } else if (event === 'decroissant') {
      this.formulesAfi[0]?.tarifs?.sort((n1: any, n2: any) => {
        var n1N = +this.ate(n1.montant);
        var n2N = +this.ate(n2.montant);
        return n2N - n1N;
      });
    }
  }

  receipFiltreNiveau(event: any) {
    this.storedData.controlListeParam = event;
    this.defaultcontrolListeParam = event;
    this.quotationForm.vadInfo.tarifier = 'non_scoring';
    this.quotationForm.vadInfo.tarifsTout = this.formulesAfi[0].tarifsTout;

    this.refreshPricingsAsync();
    // this.formulesAfi[0].tarifs
  }

  // Variable text garenties
  soinsMedicaux: string = '';
  hospitalisation!: string;
  optique!: string;
  dentaire!: string;
  auditif!: string;
  //text par point fort de type produit
  pointForTypeProduit: string = '';

  pathImg: string = 'assets/img/edit.svg';
  pathCegema!: string;
  root: string = 'http://afisante.prod2013.afiassurances.fr/docs/';
  public isLoadingMetas = false;
  selectedFormulesAfi!: string;
  selectedProduitAfi!: string;
  produit!: string;
  @Input()
  formulas!: PolicyModels.FormulaMetadataDictionary;
  @Input()
  expanded = true;
  @Input()
  selectedFormula!: QuotationModels.FormulaChoice;

  @Input() readonly = false;

  @Input()
  isLoading = false;

  @Input()
  optionsWording!: string;

  @Input()
  staggering = QuotationModels.QuittancementEnum.Annuel;

  @Input()
  package!: PolicyModels.PackageEnum;

  @Input()
  insuranceType!: CommonModels.InsuranceTypeEnum;
  @Input()
  listeReponseAfi!: QuotationModels.ReponseAfiExport[];

  @Output()
  changes = new EventEmitter<QuotationModels.FormulaChoice>();
  //public personne: Personne = new Personne("", "", "", "", "", "", "", "", , "", "", "", "");
  isAutoType = true;
  isFirstLoading = true;
  error = null;

  lead_id_temp = '';

  public formulasWithGroup: PolicyModels.FormulaWithFormGroup[] | any = [];
  public currentFormulaWithGroup!: PolicyModels.FormulaWithFormGroup | any;

  public UniversBesoinTypeEnum = HealthModels.UniversBesoinTypeEnum;

  public optionalWarrantiesDescriptions: any = {};
  public optionalWarrantiesPercentages: any = {};
  public universalNeedsWithImage: any = {};

  private formula$ = new Subject<PolicyModels.FormulaMetadata>();
  isUpdating = false;
  quotationForm!: HealthModels.QuotationForm | any;
  quotationParamOrigin!: string | any;
  quotationCodeOrigin!: string | any;
  quotationCodeParrain!: string | any;
  quotationBaseOrigin!: string | any;
  quotationAcceptCompMT!: string | any;
  quotationNavigator!: QuotationModels.Navigator;
  defaultBrokerFees!: QuotationModels.BrokerFeesChoice;
  defaultcontrolListeParam!: Question[];
  currentStaggering!: QuotationModels.QuittancementEnum;
  defaultFormulaChoice!: QuotationModels.FormulaChoice;
  clientPrice!: QuotationModels.Staggered<number>;
  brokerCommissions!: QuotationModels.Staggered<number>;
  quotation!: HealthModels.QuotationSummary;
  messageNow: string = '';
  personne!: Personne | any;
  subscription: Subscription = new Subscription();
  storedData!: HealthModels.HealthQuotationStoredData;
  typePicto: any = QuotationModels.TypePicto;

  textNombreFormule!: string;
  produitsAutorisesTous: string[] = [
    'PREVOIR_IMM_SANTE_FAMILLE_ECO',
    'PREVOIR_IMM_SANTE_FAMILLE',
    'PREVOIR_IMM_SANTE_SENIOR_ECO',
    'PREVOIR_IMM_SANTE_SENIOR',
    'AESIO_IMM_SANTE_FAMILLE_ECO',
    'AESIO_IMM_SANTE_FAMILLE',
    'AESIO_IMM_SANTE_SENIOR_ECO',
    'AESIO_IMM_SANTE_SENIOR',
    'RELAXEO2',
    'ESS_SANTE_FAMILLE',
    'ESS_SANTE_SENIOR',
    'ZEN_SANTE_FAMILLE',
    'ZEN_SANTE_55_PLUS',
    'ZEN_SANTE_SENIOR',
    'ZEN_SANTE_SENIOR_ECO',
    'PROGR_SANTE_SENIOR',
    'AC_PRIVILEGE',
    'PROGR_SANTE_FAMILLE',
    'PROGR_SANTE_FAMILLE_NR',
    'MEILLEURTAUX_VITA_SANTE_55_PLUS_NR',
    'MEILLEURTAUX_VITA_SANTE_55_PLUS_ECO_NR',
    'MEILLEURTAUX_VITA_SANTE_FAMILLE_ECO_NR',
    'MEILLEURTAUX_VITA_SANTE_FAMILLE_NR',
    'ESSENTIEL_PLUS_SANTE',
    'ESSENTIEL_PLUS_SANTE_ECO',
  ];
  produitsMtxSanteAni: string[] = [
    'PREVOIR_IMM_SANTE_FAMILLE_ECO',
    'PREVOIR_IMM_SANTE_FAMILLE',
    'AESIO_IMM_SANTE_FAMILLE_ECO',
    'AESIO_IMM_SANTE_FAMILLE',
    'RELAXEO2',
    'ESS_SANTE_FAMILLE',
    'AC_PRIVILEGE',
    'PROGR_SANTE_FAMILLE',
    'PROGR_SANTE_FAMILLE_NR',
    'MEILLEURTAUX_VITA_SANTE_FAMILLE_ECO_NR',
    'MEILLEURTAUX_VITA_SANTE_FAMILLE_NR',
  ];
  ecoSuffixTarifs = [
    'AESIO_IMM_SANTE_FAMILLE_ECO',
    'AESIO_IMM_SANTE_SENIOR_ECO',
    'PREVOIR_IMM_SANTE_FAMILLE_ECO',
    'PREVOIR_IMM_SANTE_SENIOR_ECO',
    'MEILLEURTAUX_VITA_SANTE_55_PLUS_ECO_NR',
    'MEILLEURTAUX_VITA_SANTE_FAMILLE_ECO_NR',
  ];
  readonly mtxLogoProduitsTarifs: string[] = [
    'PREVOIR_IMM_SANTE_FAMILLE_ECO',
    'PREVOIR_IMM_SANTE_FAMILLE',
    'AESIO_IMM_SANTE_FAMILLE_ECO',
    'AESIO_IMM_SANTE_FAMILLE',
    'PREVOIR_IMM_SANTE_SENIOR_ECO',
    'PREVOIR_IMM_SANTE_SENIOR',
    'AESIO_IMM_SANTE_SENIOR_ECO',
    'AESIO_IMM_SANTE_SENIOR',
    'RELAXEO2',
    'AC_PRIVILEGE',
    'PROGR_SANTE_SENIOR',
    'PROGR_SANTE_FAMILLE',
    'ESS_SANTE_SENIOR',
    'MEILLEURTAUX_VITA_SANTE_55_PLUS_NR',
    'MEILLEURTAUX_VITA_SANTE_55_PLUS_ECO_NR',
    'MEILLEURTAUX_VITA_SANTE_FAMILLE_ECO_NR',
    'MEILLEURTAUX_VITA_SANTE_FAMILLE_NR',
    'ESSENTIEL_PLUS_SANTE',
    'ESSENTIEL_PLUS_SANTE_ECO',
  ];
  readonly zeniooLogoProduitsTarifs: string[] = [
    'ZEN_SANTE_FAMILLE',
    'ZEN_SANTE_55_PLUS',
    'ZEN_SANTE_SENIOR',
    'ZEN_SANTE_SENIOR_ECO',
    'ZEN_SANTE_FOCUS_55_PLUS',
    'ZEN_SANTE_FOCUS_FAMILLE',
  ];
  templateDisplay: boolean = false;
  accordionDisplayMap: { [key: string]: boolean } = {};
  constructor(
    private fb: FormBuilder,
    @Inject(DOCUMENT) private document: Document,
    private healthInsuranceService: HealthInsuranceService,
    private healthQuotationService: HealthQuotationService,
    private fileService: FileService,
    private interactionService: InteractionService,
    public dialog: MatDialog,
    private myDataService: MyDataService,
    private taggingService: TaggingService,
    private loadingService: LoadingService,
    private router: Router,
    private loggerService: LoggerService,
    private documentTabService: DocumentTabService,
  ) {
    super();
    let query = window.matchMedia('only screen and (max-width: 750px)');
    let $this = this;

    query.addListener((query) => {
      if (query.matches) {
        $this.isMobile = true;
      } else {
        $this.isMobile = false;
      }
    });

    effect(() => {
      this.personne = this.myDataService.personneData();
    });
  }

  ngAfterViewInit() {
    this.applyStylesAndImages();
  }

  ngAfterViewChecked() {
    this.correctInfobuleWidth();
  }

  ngAfterContentChecked() {
    this.correctInfobuleWidth();
  }

  correctInfobuleWidth() {
    let sizepx = $.default('.offreBloc:first').width();

    if (!this.isMobile && sizepx) {
      $.default('.infobulletext').css('width', sizepx * 0.75 + 'px');
    }
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.healthInsuranceService.updateStepper(1);
    }, 0);

    //Get value of personne model on sessionStorage
    const value = sessionStorage.getItem('app.personne');
    if (value) {
      this.personne = JSON.parse(value);
    }
    //Set leadId on storage
    sessionStorage.setItem(
      'app.lead',
      JSON.stringify(this.formulesAfi[0].lead_id),
    );

    if (window['tC']) {
      let sha256Mail = '';
      let md5Mail = '';

      sha256Mail = CryptoJS.SHA256(this.personne.email).toString(
        CryptoJS.enc.Hex,
      );
      md5Mail = CryptoJS.MD5(this.personne.email).toString(CryptoJS.enc.Hex);

      let VisiteurId = this.taggingService.checkVisiteurId();

      let age = this.calcAge(this.personne.dateNaissanceAssure);

      window['tc_vars'] = {
        env_site: 'meilleurtaux santé',
        env_work: 'production',
        env_visiteur_id: VisiteurId,
        page_nom: 'resultats des tarifs',
        page_metier: 'sante',
        page_template: 'resultat tunnel',
        page_tunnel: 'comparer les offres',
        tunnel_demande: '',
        tunnel_etape: '',
        tunnel_num_etape: '',
        tunnel_nom_etape: '',
        tunnel_nom_sous_etape: '',
        user_email: this.personne.email,
        user_email_sha256: sha256Mail,
        user_email_md5: md5Mail,
      };

      if (age >= 0) {
        window['tc_vars']['event_user_age'] = age + '';
      }

      if (this.formulesAfi[0].lead_id != '') {
        this.lead_id_temp = this.formulesAfi?.[0].lead_id!;
        window['tc_vars'] = {
          env_site: 'meilleurtaux santé',
          env_work: 'production',
          env_visiteur_id: VisiteurId,
          page_nom: 'resultats des tarifs',
          page_metier: 'sante',
          page_template: 'resultat tunnel',
          page_tunnel: 'comparer les offres',
          tunnel_demande: '',
          tunnel_etape: '',
          tunnel_num_etape: '',
          tunnel_nom_etape: '',
          tunnel_nom_sous_etape: '',
          user_email: this.personne.email,
          user_email_sha256: sha256Mail,
          user_email_md5: md5Mail,
          lead_id: this.formulesAfi[0].lead_id,
          lead_typologie: 'lead froid',
        };

        if (age >= 0) {
          window['tc_vars']['event_user_age'] = age + '';
        }

        window['tC'].event.lead(this, {
          event_id: 'lead',
          event_categorie: 'lead tunnel',
          event_nom: 'completion tunnel',
          event_lead_id: this.formulesAfi[0].lead_id,
          event_lead_typologie: 'lead froid',
          event_metier: 'sante',
          event_demande: 'comparer les offres',
          event_statut: 'succes',
          event_nombre_assure: this.personne.compositionFamiliale, //Composition famille
          event_user_genre: this.personne.sexe,
          event_user_age: this.calcAge(this.personne.dateNaissanceAssure) + '',
          event_regime: this.personne.regimeSocial,
          event_user_date_debut_contrat: this.personne.dateDebutContrat,
          event_besoin_soins: this.personne.niveauRemboursement.soinsMedicaux,
          event_besoin_hospitalisation: this.personne.niveauRemboursement.hospi,
          event_besoin_dentaire: this.personne.niveauRemboursement.dentaire,
          event_besoin_optique: this.personne.niveauRemboursement.optique,
          event_besoin_auditif: this.personne.niveauRemboursement.auditive,
          event_user_departement: this.personne.codePostal, //code postale
          event_user_telephone: this.personne.telephone,
          event_user_email_sha256: sha256Mail,
          event_user_email_md5: md5Mail,
        });

        if (age >= 0) {
          window['tc_vars']['event_user_age'] = age + '';
        }
      }
      if (this.lead_id_temp != '') {
        window['tc_vars'] = {
          env_site: 'meilleurtaux santé',
          env_work: 'production',
          env_visiteur_id: VisiteurId,
          page_nom: 'resultats des tarifs',
          page_metier: 'sante',
          page_template: 'resultat tunnel',
          page_tunnel: 'comparer les offres',
          tunnel_demande: '',
          tunnel_etape: '',
          tunnel_num_etape: '',
          tunnel_nom_etape: '',
          tunnel_nom_sous_etape: '',
          user_email: this.personne.email,
          user_email_sha256: sha256Mail,
          user_email_md5: md5Mail,
          lead_id: this.lead_id_temp,
          lead_typologie: 'lead froid',
        };

        if (age >= 0) {
          window['tc_vars']['event_user_age'] = age + '';
        }
      }
    }

    //Get data on localStorage
    this.initialize();

    this.initFormulasGroupForm();
    this.initOptionalWarraties();

    this.loadingService.loadingSubject.next(false);
  }

  override ngOnDestroy(): any {
    this.subscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['readonly']) {
      if (this.readonly) {
        this.formulasWithGroup.forEach((fg: any) => fg.formGroup.disable());
        if (this.currentFormulaWithGroup)
          this.currentFormulaWithGroup.formGroup.disable();
      } else {
        this.formulasWithGroup.forEach((fg: any) => fg.formGroup.enable());
        if (this.currentFormulaWithGroup)
          this.currentFormulaWithGroup.formGroup.enable();
      }
    }
  }

  public getFormulaWithFormGroup(
    formula: PolicyModels.FormulaMetadata,
  ): PolicyModels.FormulaWithFormGroup {
    const warrantiesFormArray = this.fb.array([]);
    let assistanceOkmCtrl: any;
    let assistanceOkmAndVehicleCtrl: any;

    let acheelSanteEcoCtrl: any, acheelSanteEcoPlusCtrl: any;

    Object.values(formula.optionalWarranties).forEach(
      (ow: PolicyModels.OptionalWarranty) => {
        const warrantyCtrl: any = this.fb.group({
          selected:
            this.selectedFormula.optionalWarranties.findIndex(
              (selectedOw) => selectedOw === ow.warranty,
            ) !== -1,
          type: ow.warranty,
        });

        if (ow.warranty === QuotationModels.WarrantyEnum.Assistance) {
          assistanceOkmCtrl = warrantyCtrl;
          assistanceOkmCtrl.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((v: any) => {
              if (v.selected && assistanceOkmAndVehicleCtrl) {
                assistanceOkmAndVehicleCtrl.patchValue({ selected: false });
              }
            });
        }
        if (
          ow.warranty ===
          QuotationModels.WarrantyEnum.AssistanceAvecVehiculeDeRemplacement
        ) {
          assistanceOkmAndVehicleCtrl = warrantyCtrl;
          assistanceOkmAndVehicleCtrl.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((v: any) => {
              if (v.selected && assistanceOkmCtrl) {
                assistanceOkmCtrl.patchValue({ selected: false });
              }
            });
        }

        // Acheel produit
        if (ow.warranty === QuotationModels.WarrantyEnum.AcheelSanteEco) {
          acheelSanteEcoCtrl = warrantyCtrl;
          acheelSanteEcoCtrl.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((v: any) => {
              if (v.selected && acheelSanteEcoPlusCtrl) {
                acheelSanteEcoPlusCtrl.patchValue({ selected: false });
              }
            });
        }

        if (ow.warranty === QuotationModels.WarrantyEnum.AcheelSanteEcoPlus) {
          acheelSanteEcoPlusCtrl = warrantyCtrl;
          acheelSanteEcoPlusCtrl.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((v: any) => {
              if (v.selected && acheelSanteEcoCtrl) {
                acheelSanteEcoCtrl.patchValue({ selected: false });
              }
            });
        }

        warrantiesFormArray.push(warrantyCtrl);
      },
    );

    const formulaGroup = this.fb.group({
      options: this.fb.group({}),
      optionalWarranties: warrantiesFormArray,
    });

    return {
      formGroup: formulaGroup,
      formula: formula,
      codeFormule: '',
      produit: '',
    };
  }

  public selectFormula(formulaWithGroup: PolicyModels.FormulaWithFormGroup) {
    if (this.readonly) {
      return;
    }

    setTimeout(() => {
      this.currentFormulaWithGroup = formulaWithGroup;
      this.formula$.next(formulaWithGroup.formula);
    }, 0);
  }

  handleToggleInfoBulle(event: Event) {
    let el: any = event.target;
    let element = $.default(el).next('span.infobulletext');
    if (this.isMobile) {
      if (!element.hasClass('visible')) {
        element.addClass('visible');
      } else {
        element.removeClass('visible');
      }
    }
  }

  private initFormulasGroupForm() {
    Object.values(this.formulas).forEach(
      (formula: PolicyModels.FormulaMetadata) => {
        const fg = this.getFormulaWithFormGroup(formula);
        if (fg.formula.formula === this.selectedFormula.formula) {
          this.currentFormulaWithGroup = fg;
          this.updateUniversalNeedsWithImage();
        }
        this.formulasWithGroup.push(fg);
      },
    );

    this.isAutoType = !!this.formulasWithGroup[0].formula['warranties'];

    const optionalWarrantiesValueChanges$ = this.formulasWithGroup.map(
      (fg: any) => fg.formGroup.get('optionalWarranties').valueChanges,
    );

    merge(...optionalWarrantiesValueChanges$, this.formula$)
      .pipe(takeUntil(this.destroy$), debounceTime(200))
      .subscribe((_) => {
        const optWarranties = this.currentFormulaWithGroup.formGroup
          .get('optionalWarranties')
          .value.filter((w: any) => {
            return w.selected;
          })
          .map((w: any) => w.type);

        this.updateUniversalNeedsWithImage();

        this.changes.next({
          formula: this.currentFormulaWithGroup.formula.formula,
          optionalWarranties: optWarranties,
        });
      });
  }

  private updateUniversalNeedsWithImage() {
    const optWarranties = this.currentFormulaWithGroup.formGroup
      .get('optionalWarranties')
      .value.filter((w: any) => {
        return w.selected;
      })
      .map((w: any) => w.type);

    if (
      optWarranties.indexOf(QuotationModels.WarrantyEnum.AcheelSanteEcoPlus) >=
      0
    ) {
      this.universalNeedsWithImage[
        HealthModels.UniversBesoinTypeEnum.Dentaire
      ] = true;
      this.universalNeedsWithImage[HealthModels.UniversBesoinTypeEnum.Optique] =
        true;
      this.universalNeedsWithImage[HealthModels.UniversBesoinTypeEnum.Auditif] =
        true;
    } else {
      this.universalNeedsWithImage = {};
    }
  }

  private initOptionalWarraties() {
    // Descriptions
    this.optionalWarrantiesDescriptions[
      QuotationModels.WarrantyEnum.InfinitySanteEco
    ] = [
      QuotationModels.WarrantyDescriptionEnum.AcheelSanteEcoDespLineOne,
      QuotationModels.WarrantyDescriptionEnum.AcheelSanteEcoDespLineTwo,
    ];

    this.optionalWarrantiesDescriptions[
      QuotationModels.WarrantyEnum.AcheelSanteEco
    ] = [
      QuotationModels.WarrantyDescriptionEnum.AcheelSanteEcoDespLineOne,
      QuotationModels.WarrantyDescriptionEnum.AcheelSanteEcoDespLineTwo,
    ];

    this.optionalWarrantiesDescriptions[
      QuotationModels.WarrantyEnum.AcheelSanteEcoPlus
    ] = [
      QuotationModels.WarrantyDescriptionEnum.AcheelSanteEcoPlusDespLineOne,
      QuotationModels.WarrantyDescriptionEnum.AcheelSanteEcoPlusDespLineTwo,
    ];

    //Percentage
    this.optionalWarrantiesPercentages[
      QuotationModels.WarrantyEnum.InfinitySanteEco
    ] = 5;
    this.optionalWarrantiesPercentages[
      QuotationModels.WarrantyEnum.AcheelSanteEco
    ] = 5;
    this.optionalWarrantiesPercentages[
      QuotationModels.WarrantyEnum.AcheelSanteEcoPlus
    ] = 12;
  }

  arrayFrom(n: number): any[] {
    return Array(n);
  }

  displayDetails(i: number, index: number) {
    const key = `${i}-${index}`;
    const isOpen = this.accordionDisplayMap[key] || false;

    // Toggle only the clicked item
    this.accordionDisplayMap[key] = !isOpen;

    const accordion = this.document.querySelector(
      `#accordion-body-${i}-${index}`,
    ) as HTMLElement;
    const moins = this.document.querySelector(
      `#moinsDetails-${i}-${index}`,
    ) as HTMLElement;
    const plus = this.document.querySelector(
      `#plusDetails-${i}-${index}`,
    ) as HTMLElement;

    if (this.accordionDisplayMap[key]) {
      accordion.style.display = 'block';
      moins.style.display = 'block';
      plus.style.display = 'none';
    } else {
      accordion.style.display = 'none';
      moins.style.display = 'none';
      plus.style.display = 'block';
    }
  }

  displayAccordion(btn: any) {
    var acc = btn.target.closest('.accordion');
    acc.classList.toggle('active');
    var panel = acc.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  }

  displayModals(btns: any) {
    var btn = btns.target;
    var modal = btn.nextElementSibling;
    modal.style.display = 'block';
    const body: any = this.document.querySelector('body');
    body.style.overflow = 'hidden';
  }

  onFormulaPickerChanges(changes: QuotationModels.FormulaChoice) {
    this.defaultFormulaChoice = changes;
    this.refreshPricingsAsync();
  }
  refreshPricingsAsync() {
    // this.isLoading = true;
    this.isLoadingMetas = true;
    //If metas is null, get it from session storage
    const value_metas: any = sessionStorage.getItem('app.metas');
    if (!this.metas) {
      this.metas = JSON.parse(value_metas);
    }

    this.quotationParamOrigin =
      this.healthInsuranceService.getStoredData().quotationParamOrigin;
    this.quotationCodeOrigin =
      this.healthInsuranceService.getStoredData().quotationCodeOrigin;
    this.quotationCodeParrain =
      this.healthInsuranceService.getStoredData().quotationCodeParrain;
    this.quotationBaseOrigin =
      this.healthInsuranceService.getStoredData().quotationBaseOrigin;
    this.quotationAcceptCompMT =
      this.healthInsuranceService.getStoredData().quotationAcceptCompMT;
    this.quotationNavigator =
      this.healthInsuranceService.getStoredData().quotationNavigator;

    // debugger; // utile
    this.healthQuotationService
      .getPricing(
        this.quotationForm,
        this.defaultFormulaChoice,
        this.defaultBrokerFees,
        this.defaultcontrolListeParam,
        this.currentStaggering,
        objectToArray(this.metas.formulas).map((f) => f.formula),
        this.package,
        this.quotationParamOrigin,
        this.quotationCodeOrigin,
        this.quotationBaseOrigin,
        this.quotationAcceptCompMT,
        this.quotationNavigator,
        this.quotationCodeParrain,
      )
      .pipe(
        // delayAtLeast(200),
        finalize(() => {
          //this.isLoading = false;
        }),
      )
      .subscribe(
        (pricing: any) => {
          // update formulas + optional warranties
          Object.keys(this.metas.formulas).forEach((key) => {
            const formula = this.metas.formulas[+key];
            const formulaPricing = pricing.formulas[+key];

            if (formula && formulaPricing) {
              formula.pricing = formulaPricing.pricing;
              formula.optionalWarranties = formulaPricing.optionalWarranties;
            }
          });

          this.refreshCurrentPricing(
            pricing.clientPrice,
            pricing.brokerCommissions,
            pricing['listeReponseAfi'],
          );
          this.formulesAfi = pricing['listeReponseAfi'];
          console.log('pricing', this.formulesAfi);
          this.isLoadingMetas = false;
          const personne = sessionStorage.getItem('app.personne');
          this.myDataService.setPersonne(JSON.parse(personne!) as Personne);
        },
        (err: ErrorModels.TunnelSanteError) => {
          this.interactionService.showError('Erreur', err.appMessage);
        },
      );
  }

  refreshCurrentPricing(
    client: QuotationModels.Staggered<number>,
    broker: QuotationModels.Staggered<number>,
    listeReponseAfi: QuotationModels.ReponseAfiExport[],
  ) {
    this.brokerCommissions = broker;
    this.clientPrice = client;

    this.listeReponseAfi = listeReponseAfi;
  }

  ate(a: string | null | undefined) {
    if (!a) return 0;
    a = a.replace(',', '.');
    var r: number = +a;
    return r;
  }
  async selectProduitAfi(
    produit: QuotationModels.ReponseAfiExport,
    tarif: QuotationModels.Tarif,
    index: number,
  ) {
    let $this = this;
    this.NavigateSubscription(produit, tarif);
    sessionStorage.setItem(
      'liste.listeTarif',
      JSON.stringify(this.formulesAfi[0].tarifs),
    );
    this.currentFormulaWithGroup.codeFormule = tarif.codeFormule;
    this.currentFormulaWithGroup.produit = produit.produit;

    // this.storedData.controlListeParam = event;
    // this.defaultcontrolListeParam = event;
    this.quotationForm.vadInfo.tarifier = 'non_souscrire';
    this.quotationForm.vadInfo.tarifsTout = this.formulesAfi[0].tarifsTout;
    this.quotationForm.vadInfo.tarif_Selected = tarif;
    //Rang de chaque type produit séléctionné
    this.quotationForm.vadInfo.rang = index + 1;
    this.isLoadingMetas = true;
    //If metas is null, get it from session storage
    const value_metas: any = sessionStorage.getItem('app.metas');
    if (!this.metas) {
      this.metas = JSON.parse(value_metas);
    }

    this.quotationParamOrigin =
      this.healthInsuranceService.getStoredData().quotationParamOrigin;
    this.quotationCodeOrigin =
      this.healthInsuranceService.getStoredData().quotationCodeOrigin;
    this.quotationCodeParrain =
      this.healthInsuranceService.getStoredData().quotationCodeParrain;
    this.quotationBaseOrigin =
      this.healthInsuranceService.getStoredData().quotationBaseOrigin;
    this.quotationAcceptCompMT =
      this.healthInsuranceService.getStoredData().quotationAcceptCompMT;
    this.quotationNavigator =
      this.healthInsuranceService.getStoredData().quotationNavigator;

    try {
      // debugger; // utile
      let pricing: any = await this.healthQuotationService
        .getPricing(
          this.quotationForm,
          this.defaultFormulaChoice,
          this.defaultBrokerFees,
          this.defaultcontrolListeParam,
          this.currentStaggering,
          objectToArray(this.metas.formulas).map((f) => f.formula),
          this.package,
          this.quotationParamOrigin,
          this.quotationCodeOrigin,
          this.quotationBaseOrigin,
          this.quotationAcceptCompMT,
          this.quotationNavigator,
          this.quotationCodeParrain,
        )
        .toPromise()
        .then((pricing) => pricing)
        .catch((err) => console.error(err));

      // update formulas + optional warranties
      Object.keys(this.metas.formulas).forEach((key) => {
        const formula = this.metas.formulas[+key];
        const formulaPricing = pricing.formulas[+key];

        if (formula && formulaPricing) {
          formula.pricing = formulaPricing.pricing;
          formula.optionalWarranties = formulaPricing.optionalWarranties;
        }
      });

      // this.refreshCurrentPricing(pricing.clientPrice, pricing.brokerCommissions, pricing["listeReponseAfi"]);
      this.formulesAfi = pricing['listeReponseAfi'];
      this.isLoadingMetas = false;
      //let url = pricing.listeReponseAfi[0].tarifs[0].urlSouscription;
      let url = '';
      if (
        this.formulesAfi &&
        this.formulesAfi[0] &&
        this.formulesAfi[0].tarifs &&
        this.formulesAfi[0].tarifs[0] &&
        this.formulesAfi[0].tarifs[0].urlSouscription
      ) {
        url = this.formulesAfi[0].tarifs[0].urlSouscription;
      }
      // if (environment.production) {
      //     // window.open(url, "_blank");
      //     //const a = document.createElement("a");
      //     //a.setAttribute('href', url);
      //     // a.setAttribute('target', '_blank');
      //     //a.click();
      //     $this.router.navigate(["/souscription-en-ligne"]);
      // }
      // else {
      sessionStorage.setItem('app.url', url);
      $this.router.navigate(['/souscription-en-ligne']);
      //window.open('/souscription-en-ligne', '_blank');
      // }
    } catch (err: any) {
      this.interactionService.showError('Erreur', err.appMessage);
    }
  }

  contact: string[] = [];
  result: any = '';
  //Show Modal demander devis
  openDialogDemanderDevis(
    produit: QuotationModels.ReponseAfiExport,
    tarif: QuotationModels.Tarif,
    index: number,
  ): void {
    const dialogRef = this.dialog.open(DemanderDevisDialogComponent, {
      data: {
        email: this.personne.email,
        tarif: tarif,
        currentFormulaWithGroup: this.currentFormulaWithGroup,
        dataStoredQuotation: this.storedData,
        //Rang de chaque type produit sélectionné
        numeroRang: index + 1,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.personne.email = result; //update model
        //Update controlListeParam
        if (this.defaultcontrolListeParam[12].QuestionValue != '0') {
          //contact
          this.contact =
            this.defaultcontrolListeParam[12].QuestionValue.split(';');
          //this.contact[0] = this.personne.telephone;//telephone
          this.contact[1] = this.personne.email; //email

          //Set value on controllistParam
          this.setQuestionValue(
            'Contact',
            this.contact[0] + ';' + this.contact[1],
          );
        }
      }
      this.loggerService.log('Dialog closed!');
    });
  }
  NavigateSubscription(
    produit: QuotationModels.ReponseAfiExport,
    tarif: QuotationModels.Tarif,
  ) {
    sessionStorage.setItem('app.produittarif', JSON.stringify(tarif));
  }

  openEtreRappeleDialog(
    produit: QuotationModels.ReponseAfiExport,
    tarif: QuotationModels.Tarif,
  ): void {
    const dialogRef = this.dialog.open(EtreRappeleDialogComponent, {
      data: {
        telephone: this.personne.telephone,
        produit: produit,
        tarif: tarif,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.personne.telephone = result; //update model
        //Update controlListeParam
        if (this.defaultcontrolListeParam[12].QuestionValue != '0') {
          //contact
          this.contact =
            this.defaultcontrolListeParam[12].QuestionValue.split(';');
          this.contact[0] = this.personne.telephone; //telephone
          //contact[1] = this.data.email;//email

          //Set value on controllistParam
          this.setQuestionValue(
            'Contact',
            this.contact[0] + ';' + this.contact[1],
          );
        }
      }
      this.loggerService.log('Dialog closed!');
    });
  }
  setQuestionValue(keyString: any, valeur: any) {
    var find_object: any = this.defaultcontrolListeParam.find(
      (x) => x.KeyQ == keyString,
    );

    if (keyString == 'EnfantsDateNaissance') {
      find_object.QuestionValue += valeur + ';';
    } else {
      find_object.QuestionValue = valeur;
    }
  }

  integreTextGarenties(produit: any, codeFormule: any) {
    switch (produit) {
      case TexteGarantiesModels.TypeProduitsExistant
        .PrevoirImmediatSanteFamilleEco:
      case TexteGarantiesModels.TypeProduitsExistant
        .PrevoirImmediatSanteFamille:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitImsFamilleEco;

        if (codeFormule == 'Formule 1') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau1Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau1Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau1Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau1Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau1Auditif;
        }
        if (codeFormule == 'Formule 2') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau2Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau2Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau2Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau2Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau2Auditif;
        }
        if (codeFormule == 'Formule 3') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau3Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau3Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau3Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau3Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau3Auditif;
        }
        if (codeFormule == 'Formule 4') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau4Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau4Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau4Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau4Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau4Auditif;
        }
        if (codeFormule == 'Formule 5') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau5Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau5Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau5Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau5Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau5Auditif;
        }
        if (codeFormule == 'Formule 6') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau6Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau6Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau6Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau6Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau6Auditif;
        }
        if (codeFormule == 'Formule 7') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau7Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau7Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau7Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau7Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau7Auditif;
        }
        if (codeFormule == 'Formule 8') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau8Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau8Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau8Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau8Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau8Auditif;
        }
        break;
      case TexteGarantiesModels.TypeProduitsExistant
        .AESIOImmediatSanteFamilleEco:
      case TexteGarantiesModels.TypeProduitsExistant.AESIOImmediatSanteFamille:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitImsFamilleEco;

        if (codeFormule == 'Formule 1') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau1Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau1Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau1Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau1Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau1Auditif;
        }
        if (codeFormule == 'Formule 2') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau2Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau2Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau2Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau2Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau2Auditif;
        }
        if (codeFormule == 'Formule 3') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau3Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau3Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau3Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau3Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau3Auditif;
        }
        if (codeFormule == 'Formule 4') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau4Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau4Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau4Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau4Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau4Auditif;
        }
        if (codeFormule == 'Formule 5') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau5Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau5Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau5Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau5Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau5Auditif;
        }
        if (codeFormule == 'Formule 6') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau6Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau6Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau6Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau6Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau6Auditif;
        }
        if (codeFormule == 'Formule 7') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau7Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau7Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau7Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau7Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau7Auditif;
        }
        if (codeFormule == 'Formule 8') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSFamille.niveau8Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSFamille.niveau8Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSFamille.niveau8Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSFamille.niveau8Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSFamille.niveau8Auditif;
        }
        break;
      case TexteGarantiesModels.TypeProduitsExistant.PrevoirImmediatSanteSenior:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitImsSenior;

        if (codeFormule == 'Formule 1') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau1Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau1Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau1Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau1Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau1Auditif;
        }
        if (codeFormule == 'Formule 2') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau2Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau2Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau2Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau2Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau2Auditif;
        }
        if (codeFormule == 'Formule 3') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau3Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau3Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau3Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau3Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau3Auditif;
        }
        if (codeFormule == 'Formule 4') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau4Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau4Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau4Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau4Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau4Auditif;
        }
        if (codeFormule == 'Formule 5') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau5Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau5Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau5Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau5Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau5Auditif;
        }
        if (codeFormule == 'Formule 6') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau6Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau6Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau6Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau6Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau6Auditif;
        }
        if (codeFormule == 'Formule 7') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau7Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau7Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau7Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau7Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau7Auditif;
        }
        if (codeFormule == 'Formule 8') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau8Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau8Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau8Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau8Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau8Auditif;
        }
        break;
      case TexteGarantiesModels.TypeProduitsExistant
        .PrevoirImmediatSanteSeniorEco:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitImsSeniorEco;

        if (codeFormule == 'Formule 1') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau1Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau1Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau1Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau1Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau1Auditif;
        }
        if (codeFormule == 'Formule 2') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau2Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau2Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau2Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau2Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau2Auditif;
        }
        if (codeFormule == 'Formule 3') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau3Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau3Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau3Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau3Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau3Auditif;
        }
        if (codeFormule == 'Formule 4') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau4Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau4Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau4Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau4Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau4Auditif;
        }
        if (codeFormule == 'Formule 5') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau5Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau5Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau5Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau5Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau5Auditif;
        }
        if (codeFormule == 'Formule 6') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau6Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau6Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau6Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau6Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau6Auditif;
        }
        if (codeFormule == 'Formule 7') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau7Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau7Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau7Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau7Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau7Auditif;
        }
        if (codeFormule == 'Formule 8') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau8Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau8Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau8Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau8Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau8Auditif;
        }
        break;
      case TexteGarantiesModels.TypeProduitsExistant.AESIOImmediatSanteSenior:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitImsSenior;

        if (codeFormule == 'Formule 1') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau1Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau1Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau1Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau1Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau1Auditif;
        }
        if (codeFormule == 'Formule 2') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau2Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau2Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau2Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau2Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau2Auditif;
        }
        if (codeFormule == 'Formule 3') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau3Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau3Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau3Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau3Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau3Auditif;
        }
        if (codeFormule == 'Formule 4') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau4Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau4Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau4Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau4Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau4Auditif;
        }
        if (codeFormule == 'Formule 5') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau5Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau5Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau5Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau5Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau5Auditif;
        }
        if (codeFormule == 'Formule 6') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau6Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau6Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau6Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau6Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau6Auditif;
        }
        if (codeFormule == 'Formule 7') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau7Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau7Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau7Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau7Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau7Auditif;
        }
        if (codeFormule == 'Formule 8') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSenior.niveau8Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSenior.niveau8Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSenior.niveau8Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSenior.niveau8Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSenior.niveau8Auditif;
        }
        break;
      case TexteGarantiesModels.TypeProduitsExistant
        .AESIOImmediatSanteSeniorEco:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitImsSeniorEco;

        if (codeFormule == 'Formule 1') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau1Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau1Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau1Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau1Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau1Auditif;
        }
        if (codeFormule == 'Formule 2') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau2Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau2Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau2Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau2Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau2Auditif;
        }
        if (codeFormule == 'Formule 3') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau3Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau3Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau3Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau3Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau3Auditif;
        }
        if (codeFormule == 'Formule 4') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau4Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau4Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau4Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau4Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau4Auditif;
        }
        if (codeFormule == 'Formule 5') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau5Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau5Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau5Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau5Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau5Auditif;
        }
        if (codeFormule == 'Formule 6') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau6Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau6Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau6Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau6Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau6Auditif;
        }
        if (codeFormule == 'Formule 7') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau7Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau7Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau7Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau7Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau7Auditif;
        }
        if (codeFormule == 'Formule 8') {
          this.soinsMedicaux =
            TexteGarantiesModels.EnumSoinsMedicauxIMSSeniorEco.niveau8Soins;
          this.hospitalisation =
            TexteGarantiesModels.EnumHospitalisationIMSSeniorEco.niveau8Hospi;
          this.dentaire =
            TexteGarantiesModels.EnumDentaireIMSSeniorEco.niveau8Dentaire;
          this.optique =
            TexteGarantiesModels.EnumOptiqueIMSSeniorEco.niveau8Optique;
          this.auditif =
            TexteGarantiesModels.EnumAuditifIMSSeniorEco.niveau8Auditif;
        }
        break;
      case TexteGarantiesModels.TypeProduitsExistant.Relaxeo2:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitRelaxeo2;

        if (codeFormule == 'F1') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsRelaxeo2.niveau1SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationRelaxeo2.niveau1HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireRelaxeo2.niveau1DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueRelaxeo2.niveau1OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifRelaxeo2.niveau1AuditifR;
        }
        if (codeFormule == 'F2') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsRelaxeo2.niveau2SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationRelaxeo2.niveau2HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireRelaxeo2.niveau2DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueRelaxeo2.niveau2OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifRelaxeo2.niveau2AuditifR;
        }
        if (codeFormule == 'F3') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsRelaxeo2.niveau3SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationRelaxeo2.niveau3HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireRelaxeo2.niveau3DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueRelaxeo2.niveau3OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifRelaxeo2.niveau3AuditifR;
        }
        if (codeFormule == 'F4') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsRelaxeo2.niveau4SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationRelaxeo2.niveau4HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireRelaxeo2.niveau4DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueRelaxeo2.niveau4OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifRelaxeo2.niveau4AuditifR;
        }
        if (codeFormule == 'F5') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsRelaxeo2.niveau5SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationRelaxeo2.niveau5HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireRelaxeo2.niveau5DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueRelaxeo2.niveau5OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifRelaxeo2.niveau5AuditifR;
        }
        if (codeFormule == 'F6') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsRelaxeo2.niveau6SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationRelaxeo2.niveau6HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireRelaxeo2.niveau6DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueRelaxeo2.niveau6OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifRelaxeo2.niveau6AuditifR;
        }
        break;

      // Essentiel famille
      case TexteGarantiesModels.TypeProduitsExistant.EssentielSanteFamille:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitEssentielFamille;

        if (codeFormule == 'Formule 1') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinEssentielFamille.niveau1SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielFamille.niveau1HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielFamille.niveau1DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielFamille.niveau1OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielFamille.niveau1AuditifR;
        }
        if (codeFormule == 'Formule 2') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinEssentielFamille.niveau2SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielFamille.niveau2HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielFamille.niveau2DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielFamille.niveau2OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielFamille.niveau2AuditifR;
        }
        if (codeFormule == 'Formule 3') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinEssentielFamille.niveau3SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielFamille.niveau3HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielFamille.niveau3DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielFamille.niveau3OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielFamille.niveau3AuditifR;
        }
        if (codeFormule == 'Formule 4') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinEssentielFamille.niveau4SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielFamille.niveau4HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielFamille.niveau4DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielFamille.niveau4OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielFamille.niveau4AuditifR;
        }
        if (codeFormule == 'Formule 5') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinEssentielFamille.niveau5SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielFamille.niveau5HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielFamille.niveau1DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielFamille.niveau5OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielFamille.niveau5AuditifR;
        }
        if (codeFormule == 'Formule 6') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinEssentielFamille.niveau6SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielFamille.niveau6HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielFamille.niveau6DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielFamille.niveau6OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielFamille.niveau6AuditifR;
        }
        break;

      // Essentiel Senior
      case TexteGarantiesModels.TypeProduitsExistant.EssentielSanteSenior:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitEssentielSenior;

        if (codeFormule == 'Formule 1') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsEssentielSenior.niveau1SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielSenior.niveau1HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielSenior.niveau1DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielSenior.niveau1OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielSenior.niveau1AuditifR;
        }
        if (codeFormule == 'Formule 2') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsEssentielSenior.niveau2SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielSenior.niveau2HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielSenior.niveau2DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielSenior.niveau2OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielSenior.niveau2AuditifR;
        }
        if (codeFormule == 'Formule 3') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsEssentielSenior.niveau3SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielSenior.niveau3HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielSenior.niveau3DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielSenior.niveau3OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielSenior.niveau3AuditifR;
        }
        if (codeFormule == 'Formule 4') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsEssentielSenior.niveau4SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielSenior.niveau4HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielSenior.niveau4DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielSenior.niveau4OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielSenior.niveau4AuditifR;
        }
        if (codeFormule == 'Formule 5') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsEssentielSenior.niveau5SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielSenior.niveau5HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielSenior.niveau1DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielSenior.niveau5OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielSenior.niveau5AuditifR;
        }
        if (codeFormule == 'Formule 6') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsEssentielSenior.niveau6SoinsR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielSenior.niveau6HospiR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielSenior.niveau6DentaireR;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielSenior.niveau6OptiqueR;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielSenior.niveau6AuditifR;
        }
        break;

      //CEGEMA Vitaneor3
      case TexteGarantiesModels.TypeProduitsExistant.Vitaneor3:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitVitaneor3;

        if (codeFormule == 'F1') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsVitaneor3.soinsNiveau1;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationVitaneor3.hospiNiveau1;
          this.optique =
            TexteGarantiesModels.enumOptiqueVitaneor3.optiqueNiveau1;
          this.dentaire =
            TexteGarantiesModels.enumDentaireVitaneor3.dentaireNiveau1;
          this.auditif =
            TexteGarantiesModels.enumAuditifVitaneor3.auditifNiveau1;
        }
        if (codeFormule == 'F2') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsVitaneor3.soinsNiveau2;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationVitaneor3.hospiNiveau2;
          this.optique =
            TexteGarantiesModels.enumOptiqueVitaneor3.optiqueNiveau2;
          this.dentaire =
            TexteGarantiesModels.enumDentaireVitaneor3.dentaireNiveau2;
          this.auditif =
            TexteGarantiesModels.enumAuditifVitaneor3.auditifNiveau2;
        }
        if (codeFormule == 'F3') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsVitaneor3.soinsNiveau3;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationVitaneor3.hospiNiveau3;
          this.optique =
            TexteGarantiesModels.enumOptiqueVitaneor3.optiqueNiveau3;
          this.dentaire =
            TexteGarantiesModels.enumDentaireVitaneor3.dentaireNiveau3;
          this.auditif =
            TexteGarantiesModels.enumAuditifVitaneor3.auditifNiveau3;
        }
        if (codeFormule == 'F4') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsVitaneor3.soinsNiveau4;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationVitaneor3.hospiNiveau4;
          this.optique =
            TexteGarantiesModels.enumOptiqueVitaneor3.optiqueNiveau4;
          this.dentaire =
            TexteGarantiesModels.enumDentaireVitaneor3.dentaireNiveau4;
          this.auditif =
            TexteGarantiesModels.enumAuditifVitaneor3.auditifNiveau4;
        }
        if (codeFormule == 'F5') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsVitaneor3.soinsNiveau5;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationVitaneor3.hospiNiveau5;
          this.optique =
            TexteGarantiesModels.enumOptiqueVitaneor3.optiqueNiveau5;
          this.dentaire =
            TexteGarantiesModels.enumDentaireVitaneor3.dentaireNiveau5;
          this.auditif =
            TexteGarantiesModels.enumAuditifVitaneor3.auditifNiveau5;
        }
        if (codeFormule == 'F6') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsVitaneor3.soinsNiveau6;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationVitaneor3.hospiNiveau6;
          this.optique =
            TexteGarantiesModels.enumOptiqueVitaneor3.optiqueNiveau6;
          this.dentaire =
            TexteGarantiesModels.enumDentaireVitaneor3.dentaireNiveau6;
          this.auditif =
            TexteGarantiesModels.enumAuditifVitaneor3.auditifNiveau6;
        }
        break;
      //CEGEMA Essentiel2
      case TexteGarantiesModels.TypeProduitsExistant.Essentiel2:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitVitaneor3;

        if (codeFormule == 'Initiale') {
          this.pointForTypeProduit =
            TexteGarantiesModels.enumTexteTypeproduit.InitialPlus;
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsEssentiel2.soinsInitiale;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentiel2.hospiInitiale;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentiel2.dentaireInitiale;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentiel2.optiqueInitiale;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentiel2.auditifInitiale;
        }
        if (codeFormule == 'E1') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsEssentiel2.soinsNiveau1;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentiel2.hospiNiveau1;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentiel2.dentaireNiveau1;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentiel2.optiqueNiveau1;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentiel2.auditifNiveau1;
        }
        if (codeFormule == 'E2') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsEssentiel2.soinsNiveau2;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentiel2.hospiNiveau2;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentiel2.dentaireNiveau2;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentiel2.optiqueNiveau2;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentiel2.auditifNiveau2;
        }
        if (codeFormule == 'E3') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsEssentiel2.soinsNiveau3;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentiel2.hospiNiveau3;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentiel2.dentaireNiveau3;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentiel2.optiqueNiveau3;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentiel2.auditifNiveau3;
        }
        if (codeFormule == 'E4') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsEssentiel2.soinsNiveau4;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentiel2.hospiNiveau4;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentiel2.dentaireNiveau4;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentiel2.optiqueNiveau4;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentiel2.auditifNiveau4;
        }
        break;
      //APIVIA vitamin3
      case TexteGarantiesModels.TypeProduitsExistant.Vitamin3:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitVitamin3;

        if (codeFormule == 'F1') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsVitamin3.soinsNiveau1;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationVitamin3.hospiNiveau1;
          this.dentaire =
            TexteGarantiesModels.enumDentaireVitamin3.dentaireNiveau1;
          this.optique =
            TexteGarantiesModels.enumOptiqueVitamin3.optiqueNiveau1;
          this.auditif =
            TexteGarantiesModels.enumAuditifVitamin3.auditifNiveau1;
        }
        if (codeFormule == 'F2') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsVitamin3.soinsNiveau2;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationVitamin3.hospiNiveau2;
          this.dentaire =
            TexteGarantiesModels.enumDentaireVitamin3.dentaireNiveau2;
          this.optique =
            TexteGarantiesModels.enumOptiqueVitamin3.optiqueNiveau2;
          this.auditif =
            TexteGarantiesModels.enumAuditifVitamin3.auditifNiveau2;
        }
        if (codeFormule == 'F3') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsVitamin3.soinsNiveau3;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationVitamin3.hospiNiveau3;
          this.dentaire =
            TexteGarantiesModels.enumDentaireVitamin3.dentaireNiveau3;
          this.optique =
            TexteGarantiesModels.enumOptiqueVitamin3.optiqueNiveau3;
          this.auditif =
            TexteGarantiesModels.enumAuditifVitamin3.auditifNiveau3;
        }
        if (codeFormule == 'F4') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsVitamin3.soinsNiveau4;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationVitamin3.hospiNiveau4;
          this.dentaire =
            TexteGarantiesModels.enumDentaireVitamin3.dentaireNiveau4;
          this.optique =
            TexteGarantiesModels.enumOptiqueVitamin3.optiqueNiveau4;
          this.auditif =
            TexteGarantiesModels.enumAuditifVitamin3.auditifNiveau4;
        }
        if (codeFormule == 'F5') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsVitamin3.soinsNiveau5;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationVitamin3.hospiNiveau5;
          this.dentaire =
            TexteGarantiesModels.enumDentaireVitamin3.dentaireNiveau5;
          this.optique =
            TexteGarantiesModels.enumOptiqueVitamin3.optiqueNiveau5;
          this.auditif =
            TexteGarantiesModels.enumAuditifVitamin3.auditifNiveau5;
        }
        break;

      case TexteGarantiesModels.TypeProduitsExistant.SwissLifeRetraite:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitSwissLifeRetraite;

        if (codeFormule == 'F1') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeRetraite.niveau1SoinsSR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeRetraite.niveau1HospiSR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeRetraite.niveau1DentaireSR;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeRetraite.niveau1OptiqueSR;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeRetraite.niveau1AuditifSR;
        }
        if (codeFormule == 'F2') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeRetraite.niveau2SoinsSR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeRetraite.niveau2HospiSR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeRetraite.niveau2DentaireSR;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeRetraite.niveau2OptiqueSR;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeRetraite.niveau2AuditifSR;
        }
        if (codeFormule == 'F3') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeRetraite.niveau3SoinsSR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeRetraite.niveau3HospiSR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeRetraite.niveau3DentaireSR;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeRetraite.niveau3OptiqueSR;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeRetraite.niveau3AuditifSR;
        }
        if (codeFormule == 'F4') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeRetraite.niveau4SoinsSR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeRetraite.niveau4HospiSR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeRetraite.niveau4DentaireSR;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeRetraite.niveau4OptiqueSR;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeRetraite.niveau4AuditifSR;
        }
        if (codeFormule == 'F5') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeRetraite.niveau5SoinsSR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeRetraite.niveau5HospiSR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeRetraite.niveau5DentaireSR;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeRetraite.niveau5OptiqueSR;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeRetraite.niveau5AuditifSR;
        }
        if (codeFormule == 'F6') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeRetraite.niveau6SoinsSR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeRetraite.niveau6HospiSR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeRetraite.niveau6DentaireSR;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeRetraite.niveau6OptiqueSR;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeRetraite.niveau6AuditifSR;
        }
        if (codeFormule == 'F7') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeRetraite.niveau7SoinsSR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeRetraite.niveau7HospiSR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeRetraite.niveau7DentaireSR;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeRetraite.niveau7OptiqueSR;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeRetraite.niveau7AuditifSR;
        }
        if (codeFormule == 'F8') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeRetraite.niveau8SoinsSR;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeRetraite.niveau8HospiSR;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeRetraite.niveau8DentaireSR;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeRetraite.niveau1OptiqueSR;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeRetraite.niveau8AuditifSR;
        }
        break;
      case TexteGarantiesModels.TypeProduitsExistant.SwissLifeParticulier:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitSwissLifeParticulier;

        if (codeFormule == 'F1') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeParticulier.niveau1SoinsSP;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeParticulier.niveau1HospiSP;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeParticulier.niveau1DentaireSP;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeParticulier.niveau1OptiqueSP;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeParticulier.niveau1AuditifSP;
        }
        if (codeFormule == 'F2') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeParticulier.niveau2SoinsSP;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeParticulier.niveau2HospiSP;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeParticulier.niveau2DentaireSP;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeParticulier.niveau2OptiqueSP;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeParticulier.niveau2AuditifSP;
        }
        if (codeFormule == 'F3') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeParticulier.niveau3SoinsSP;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeParticulier.niveau3HospiSP;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeParticulier.niveau3DentaireSP;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeParticulier.niveau3OptiqueSP;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeParticulier.niveau3AuditifSP;
        }
        if (codeFormule == 'F4') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeParticulier.niveau4SoinsSP;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeParticulier.niveau4HospiSP;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeParticulier.niveau4DentaireSP;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeParticulier.niveau4OptiqueSP;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeParticulier.niveau4AuditifSP;
        }
        if (codeFormule == 'F5') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeParticulier.niveau5SoinsSP;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeParticulier.niveau5HospiSP;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeParticulier.niveau5DentaireSP;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeParticulier.niveau5OptiqueSP;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeParticulier.niveau5AuditifSP;
        }
        if (codeFormule == 'F6') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeParticulier.niveau6SoinsSP;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeParticulier.niveau6HospiSP;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeParticulier.niveau6DentaireSP;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeParticulier.niveau6OptiqueSP;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeParticulier.niveau6AuditifSP;
        }
        if (codeFormule == 'F7') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeParticulier.niveau7SoinsSP;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeParticulier.niveau7HospiSP;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeParticulier.niveau7DentaireSP;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeParticulier.niveau7OptiqueSP;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeParticulier.niveau7AuditifSP;
        }
        if (codeFormule == 'F8') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinsSwissLifeParticulier.niveau8SoinsSP;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationSwissLifeParticulier.niveau8HospiSP;
          this.dentaire =
            TexteGarantiesModels.enumDentaireSwissLifeParticulier.niveau8DentaireSP;
          this.optique =
            TexteGarantiesModels.enumOptiqueSwissLifeParticulier.niveau1OptiqueSP;
          this.auditif =
            TexteGarantiesModels.enumAuditifSwissLifeParticulier.niveau8AuditifSP;
        }
        break;

      //ZENIOO SANTE FAMILLE
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteFamille:
      case TextGarantieModelZenioo.TypeProduitsExistant
        .ZeniooSanteFamilleEcoDentaire:
      case TextGarantieModelZenioo.TypeProduitsExistant
        .ZeniooSanteFamilleEcoOptique:
      case TextGarantieModelZenioo.TypeProduitsExistant
        .ZeniooSanteFamilleEcoOptiqueDentaire:
        this.pointForTypeProduit =
          TextGarantieModelZenioo.enumTexteTypeProduit.typeProduitZenioooSanteIntegrale;

        if (codeFormule == 'MO-60-10-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZeniooFamille.niveau1SoinsZF;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZF.niveau1HospiZF;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZF.niveau1DentaireZF;
          this.optique = TextGarantieModelZenioo.enumOptiqueZF.niveau1OptiqueZF;
          this.auditif = TextGarantieModelZenioo.enumAuditifZF.niveau1AuditifZF;
        }
        if (codeFormule == 'MO-60-20-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZeniooFamille.niveau2SoinsZF;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZF.niveau2HospiZF;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZF.niveau2DentaireZF;
          this.optique = TextGarantieModelZenioo.enumOptiqueZF.niveau2OptiqueZF;
          this.auditif = TextGarantieModelZenioo.enumAuditifZF.niveau2AuditifZF;
        }
        if (codeFormule == 'MO-60-30-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZeniooFamille.niveau3SoinsZF;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZF.niveau3HospiZF;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZF.niveau3DentaireZF;
          this.optique = TextGarantieModelZenioo.enumOptiqueZF.niveau3OptiqueZF;
          this.auditif = TextGarantieModelZenioo.enumAuditifZF.niveau3AuditifZF;
        }
        if (codeFormule == 'MO-60-40-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZeniooFamille.niveau4SoinsZF;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZF.niveau4HospiZF;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZF.niveau4DentaireZF;
          this.optique = TextGarantieModelZenioo.enumOptiqueZF.niveau4OptiqueZF;
          this.auditif = TextGarantieModelZenioo.enumAuditifZF.niveau4AuditifZF;
        }
        if (codeFormule == 'MO-60-50-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZeniooFamille.niveau5SoinsZF;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZF.niveau5HospiZF;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZF.niveau5DentaireZF;
          this.optique = TextGarantieModelZenioo.enumOptiqueZF.niveau5OptiqueZF;
          this.auditif = TextGarantieModelZenioo.enumAuditifZF.niveau5AuditifZF;
        }
        break;
      //ZENIOO SANTE INTEGRALE 55 PLUS
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteCCPlus:
      case TextGarantieModelZenioo.TypeProduitsExistant
        .ZeniooSanteCCPlusEcoDentaire:
      case TextGarantieModelZenioo.TypeProduitsExistant
        .ZeniooSanteCCPlusEcoOptique:
      case TextGarantieModelZenioo.TypeProduitsExistant
        .ZeniooSanteCCPlusEcoOptiqueDentaire:
        this.pointForTypeProduit =
          TextGarantieModelZenioo.enumTexteTypeProduit.typeProduitZenioooSanteIntegrale;

        if (codeFormule == 'MO-50-10-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZeniooCCPlus.niveau1SoinsZCCPlus;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZCCPlus.niveau1HospiZCCPlus;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZCCPlus.niveau1DentaireZCCPlus;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZCCPlus.niveau1OptiqueZCCPlus;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZCCPlus.niveau1AuditifZCCPlus;
        }
        if (codeFormule == 'MO-50-20-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZeniooCCPlus.niveau2SoinsZCCPlus;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZCCPlus.niveau2HospiZCCPlus;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZCCPlus.niveau2DentaireZCCPlus;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZCCPlus.niveau2OptiqueZCCPlus;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZCCPlus.niveau2AuditifZCCPlus;
        }
        if (codeFormule == 'MO-50-30-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZeniooCCPlus.niveau3SoinsZCCPlus;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZCCPlus.niveau3HospiZCCPlus;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZCCPlus.niveau3DentaireZCCPlus;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZCCPlus.niveau3OptiqueZCCPlus;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZCCPlus.niveau3AuditifZCCPlus;
        }
        if (codeFormule == 'MO-50-40-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZeniooCCPlus.niveau4SoinsZCCPlus;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZCCPlus.niveau4HospiZCCPlus;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZCCPlus.niveau4DentaireZCCPlus;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZCCPlus.niveau4OptiqueZCCPlus;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZCCPlus.niveau4AuditifZCCPlus;
        }
        if (codeFormule == 'MO-50-50-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZeniooCCPlus.niveau5SoinsZCCPlus;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZCCPlus.niveau5HospiZCCPlus;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZCCPlus.niveau5DentaireZCCPlus;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZCCPlus.niveau5OptiqueZCCPlus;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZCCPlus.niveau5AuditifZCCPlus;
        }
        if (codeFormule == 'MO-50-60-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZeniooCCPlus.niveau6SoinsZCCPlus;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZCCPlus.niveau6HospiZCCPlus;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZCCPlus.niveau6DentaireZCCPlus;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZCCPlus.niveau6OptiqueZCCPlus;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZCCPlus.niveau6AuditifZCCPlus;
        }
        break;
      //ZENIOO SANTE SENIOR
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteSenior:
        this.pointForTypeProduit =
          TextGarantieModelZenioo.enumTexteTypeProduit.tpZeniooSanteSenior;

        //niveau Hospi
        if (codeFormule == 'MO-11-10-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZss.niveauHospiSoinsZss;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZss.niveauHospiHospiZss;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZss.niveauHospiDentaireZss;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZss.niveauHospiOptiqueZss;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZss.niveauHospiAuditifZss;
        }
        if (codeFormule == 'MO-11-20-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZss.niveau1SoinsZss;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZss.niveau1HospiZss;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZss.niveau1DentaireZss;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZss.niveau1OptiqueZss;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZss.niveau1AuditifZss;
        }
        if (codeFormule == 'MO-11-30-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZss.niveau2SoinsZss;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZss.niveau2HospiZss;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZss.niveau2DentaireZss;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZss.niveau2OptiqueZss;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZss.niveau2AuditifZss;
        }
        if (codeFormule == 'MO-11-40-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZss.niveau3SoinsZss;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZss.niveau3HospiZss;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZss.niveau3DentaireZss;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZss.niveau3OptiqueZss;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZss.niveau3AuditifZss;
        }
        if (codeFormule == 'MO-11-50-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZss.niveau4SoinsZss;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZss.niveau4HospiZss;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZss.niveau4DentaireZss;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZss.niveau4OptiqueZss;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZss.niveau4AuditifZss;
        }
        if (codeFormule == 'MO-11-60-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZss.niveau5SoinsZss;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZss.niveau5HospiZss;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZss.niveau5DentaireZss;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZss.niveau5OptiqueZss;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZss.niveau5AuditifZss;
        }
        if (codeFormule == 'MO-11-70-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZss.niveau6SoinsZss;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZss.niveau6HospiZss;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZss.niveau6DentaireZss;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZss.niveau6OptiqueZss;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZss.niveau6AuditifZss;
        }
        break;

      //ZENIOO SANTE FOCUS FAMILLE
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteFocusFamille:
        this.pointForTypeProduit =
          TextGarantieModelZenioo.enumTexteTypeProduit.tpZeniooSanteFocusFamille;

        if (codeFormule == 'MO-110-10-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZsff.niveau1SoinsZsff;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZsff.niveau1SoinsZsff;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZsff.niveau1DentaireZsff;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZsff.niveau1OptiqueZsff;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZsff.niveau1AuditifZsff;
        }

        if (codeFormule == 'MO-110-20-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZsff.niveau2SoinsZsff;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZsff.niveau2SoinsZsff;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZsff.niveau2DentaireZsff;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZsff.niveau2OptiqueZsff;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZsff.niveau2AuditifZsff;
        }

        if (codeFormule == 'MO-110-30-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZsff.niveau3SoinsZsff;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZsff.niveau3SoinsZsff;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZsff.niveau3DentaireZsff;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZsff.niveau3OptiqueZsff;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZsff.niveau3AuditifZsff;
        }

        if (codeFormule == 'MO-110-40-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZsff.niveau4SoinsZsff;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZsff.niveau4SoinsZsff;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZsff.niveau4DentaireZsff;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZsff.niveau4OptiqueZsff;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZsff.niveau4AuditifZsff;
        }

        if (codeFormule == 'MO-110-50-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZsff.niveau5SoinsZsff;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZsff.niveau5SoinsZsff;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZsff.niveau5DentaireZsff;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZsff.niveau5OptiqueZsff;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZsff.niveau5AuditifZsff;
        }

        if (codeFormule == 'MO-110-60-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZsff.niveau6SoinsZsff;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZsff.niveau6SoinsZsff;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZsff.niveau6DentaireZsff;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZsff.niveau6OptiqueZsff;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZsff.niveau6AuditifZsff;
        }
        break;

      /////
      //ZENIOO SANTE FOCUS 55 PLUS
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteFocusplus:
        this.pointForTypeProduit =
          TextGarantieModelZenioo.enumTexteTypeProduit.tpZeniooSanteFocusPlus;

        if (codeFormule == 'MO-100-10-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZsfp.niveau1SoinsZsfp;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZsfp.niveau1SoinsZsfp;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZsfp.niveau1DentaireZsfp;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZsfp.niveau1OptiqueZsfp;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZsfp.niveau1AuditifZsfp;
        }

        if (codeFormule == 'MO-100-20-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZsfp.niveau2SoinsZsfp;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZsfp.niveau2SoinsZsfp;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZsfp.niveau2DentaireZsfp;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZsfp.niveau2OptiqueZsfp;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZsfp.niveau2AuditifZsfp;
        }

        if (codeFormule == 'MO-100-30-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZsfp.niveau3SoinsZsfp;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZsfp.niveau3SoinsZsfp;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZsfp.niveau3DentaireZsfp;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZsfp.niveau3OptiqueZsfp;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZsfp.niveau3AuditifZsfp;
        }

        if (codeFormule == 'MO-100-40-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZsfp.niveau4SoinsZsfp;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZsfp.niveau4SoinsZsfp;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZsfp.niveau4DentaireZsfp;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZsfp.niveau4OptiqueZsfp;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZsfp.niveau4AuditifZsfp;
        }

        if (codeFormule == 'MO-100-50-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZsfp.niveau5SoinsZsfp;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZsfp.niveau5SoinsZsfp;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZsfp.niveau5DentaireZsfp;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZsfp.niveau5OptiqueZsfp;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZsfp.niveau5AuditifZsfp;
        }

        if (codeFormule == 'MO-100-60-10') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZsfp.niveau6SoinsZsfp;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZsfp.niveau6SoinsZsfp;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZsfp.niveau6DentaireZsfp;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZsfp.niveau6OptiqueZsfp;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZsfp.niveau6AuditifZsfp;
        }

        break;
      /////

      //ZENIOO SANTE SENIOR ECO
      case TextGarantieModelZenioo.TypeProduitsExistant.ZeniooSanteSeniorEco:
        this.pointForTypeProduit =
          TextGarantieModelZenioo.enumTexteTypeProduit.tpZeniooSanteSenior;

        if (codeFormule == 'MO-11-20-40') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZss.niveau1SoinsZss;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZss.niveau1HospiZss;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZss.niveau1DentaireZss;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZss.niveau1OptiqueZss;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZss.niveau1AuditifZss;
        }
        if (codeFormule == 'MO-11-30-90') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZss.niveau2SoinsZss;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZss.niveau2HospiZss;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZss.niveau2DentaireZss;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZss.niveau2OptiqueZss;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZss.niveau2AuditifZss;
        }
        if (codeFormule == 'MO-11-40-90') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZss.niveau3SoinsZss;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZss.niveau3HospiZss;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZss.niveau3DentaireZss;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZss.niveau3OptiqueZss;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZss.niveau3AuditifZss;
        }
        if (codeFormule == 'MO-11-50-90') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZss.niveau4SoinsZss;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZss.niveau4HospiZss;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZss.niveau4DentaireZss;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZss.niveau4OptiqueZss;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZss.niveau4AuditifZss;
        }
        if (codeFormule == 'MO-11-60-90') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZss.niveau5SoinsZss;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZss.niveau5HospiZss;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZss.niveau5DentaireZss;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZss.niveau5OptiqueZss;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZss.niveau5AuditifZss;
        }
        if (codeFormule == 'MO-11-70-90') {
          this.soinsMedicaux =
            TextGarantieModelZenioo.enumSoinsZss.niveau6SoinsZss;
          this.hospitalisation =
            TextGarantieModelZenioo.enumHospitalisationZss.niveau6HospiZss;
          this.dentaire =
            TextGarantieModelZenioo.enumDentaireZss.niveau6DentaireZss;
          this.optique =
            TextGarantieModelZenioo.enumOptiqueZss.niveau6OptiqueZss;
          this.auditif =
            TextGarantieModelZenioo.enumAuditifZss.niveau6AuditifZss;
        }
        break;
      //SPVIE ESSENTIELLE
      case TextGarantieModelSpvie.TypeProduitsExistant.SpvieSanteESSENTIELLE:
        this.pointForTypeProduit =
          TextGarantieModelSpvie.enumTexteTypeProduit.tpSpvieSanteSPVIE_GENIUS_ESSENTIELLE;

        if (codeFormule == 'AE') {
          this.soinsMedicaux =
            TextGarantieModelSpvie.enumSoinsSpvieESSENTIELLE.niveau1SoinsSpvie;
          this.hospitalisation =
            TextGarantieModelSpvie.enumHospitalisationSpvieESSENTIELLE.niveau1HospitalisationSpvie;
          this.dentaire =
            TextGarantieModelSpvie.enumDentaireSpvieESSENTIELLE.niveau1DentaireSpvie;
          this.optique =
            TextGarantieModelSpvie.enumOptiqueSpvieESSENTIELLE.niveau1OptiqueSpvie;
          this.auditif =
            TextGarantieModelSpvie.enumAuditifSpvieESSENTIELLE.niveau1AuditifSpvie;
        }

        if (codeFormule == 'BE') {
          this.soinsMedicaux =
            TextGarantieModelSpvie.enumSoinsSpvieESSENTIELLE.niveau2SoinsSpvie;
          this.hospitalisation =
            TextGarantieModelSpvie.enumHospitalisationSpvieESSENTIELLE.niveau2HospitalisationSpvie;
          this.dentaire =
            TextGarantieModelSpvie.enumDentaireSpvieESSENTIELLE.niveau2DentaireSpvie;
          this.optique =
            TextGarantieModelSpvie.enumOptiqueSpvieESSENTIELLE.niveau2OptiqueSpvie;
          this.auditif =
            TextGarantieModelSpvie.enumAuditifSpvieESSENTIELLE.niveau2AuditifSpvie;
        }
        if (codeFormule == 'CE') {
          this.soinsMedicaux =
            TextGarantieModelSpvie.enumSoinsSpvieESSENTIELLE.niveau3SoinsSpvie;
          this.hospitalisation =
            TextGarantieModelSpvie.enumHospitalisationSpvieESSENTIELLE.niveau3HospitalisationSpvie;
          this.dentaire =
            TextGarantieModelSpvie.enumDentaireSpvieESSENTIELLE.niveau3DentaireSpvie;
          this.optique =
            TextGarantieModelSpvie.enumOptiqueSpvieESSENTIELLE.niveau3OptiqueSpvie;
          this.auditif =
            TextGarantieModelSpvie.enumAuditifSpvieESSENTIELLE.niveau4AuditifSpvie;
        }
        if (codeFormule == 'DE') {
          this.soinsMedicaux =
            TextGarantieModelSpvie.enumSoinsSpvieESSENTIELLE.niveau4SoinsSpvie;
          this.hospitalisation =
            TextGarantieModelSpvie.enumHospitalisationSpvieESSENTIELLE.niveau4HospitalisationSpvie;
          this.dentaire =
            TextGarantieModelSpvie.enumDentaireSpvieESSENTIELLE.niveau4DentaireSpvie;
          this.optique =
            TextGarantieModelSpvie.enumOptiqueSpvieESSENTIELLE.niveau4OptiqueSpvie;
          this.auditif =
            TextGarantieModelSpvie.enumAuditifSpvieESSENTIELLE.niveau4AuditifSpvie;
        }
        break;
      //SPVIE SENIOR MALIN
      case TextGarantieModelSpvie.TypeProduitsExistant.SpvieSanteMalin:
        // case TextGarantieModelSpvie.TypeProduitsExistant.SpvieSanteSenior:
        this.pointForTypeProduit =
          TextGarantieModelSpvie.enumTexteTypeProduit.tpSpvieSanteMalin;

        if (codeFormule == 'Formule 1') {
          this.soinsMedicaux =
            TextGarantieModelSpvie.enumSoinsSpvie.niveau1SoinsSpvie;
          this.hospitalisation =
            TextGarantieModelSpvie.enumHospitalisationSpvie.niveau1HospiSpvie;
          this.dentaire =
            TextGarantieModelSpvie.enumDentaireSpvie.niveau1DentaireSpvie;
          this.optique =
            TextGarantieModelSpvie.enumOptiqueSpvie.niveau1OptiqueSpvie;
          this.auditif =
            TextGarantieModelSpvie.enumAuditifSpvie.niveau1AuditifSpvie;
        }
        if (codeFormule == 'Formule 2') {
          this.soinsMedicaux =
            TextGarantieModelSpvie.enumSoinsSpvie.niveau2SoinsSpvie;
          this.hospitalisation =
            TextGarantieModelSpvie.enumHospitalisationSpvie.niveau2HospiSpvie;
          this.dentaire =
            TextGarantieModelSpvie.enumDentaireSpvie.niveau2DentaireSpvie;
          this.optique =
            TextGarantieModelSpvie.enumOptiqueSpvie.niveau2OptiqueSpvie;
          this.auditif =
            TextGarantieModelSpvie.enumAuditifSpvie.niveau2AuditifSpvie;
        }
        if (codeFormule == 'Formule 3') {
          this.soinsMedicaux =
            TextGarantieModelSpvie.enumSoinsSpvie.niveau3SoinsSpvie;
          this.hospitalisation =
            TextGarantieModelSpvie.enumHospitalisationSpvie.niveau3HospiSpvie;
          this.dentaire =
            TextGarantieModelSpvie.enumDentaireSpvie.niveau3DentaireSpvie;
          this.optique =
            TextGarantieModelSpvie.enumOptiqueSpvie.niveau3OptiqueSpvie;
          this.auditif =
            TextGarantieModelSpvie.enumAuditifSpvie.niveau3AuditifSpvie;
        }
        break;
      //OPTIMUM
      case TexteGarantiesModels.TypeProduitsExistant.Optimum:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitOptimum;

        if (codeFormule == 'Formule 1') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinOptimum.niveau1SoinsOpt;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationOptimum.niveau1HospiOpt;
          this.dentaire =
            TexteGarantiesModels.enumDentaireOptimum.niveau1DentaireOpt;
          this.optique =
            TexteGarantiesModels.enumOptiqueOptimum.niveau1OptiqueOpt;
          this.auditif =
            TexteGarantiesModels.enumAuditifOptimum.niveau1AuditifOpt;
        }
        if (codeFormule == 'Formule 2') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinOptimum.niveau2SoinsOpt;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationOptimum.niveau2HospiOpt;
          this.dentaire =
            TexteGarantiesModels.enumDentaireOptimum.niveau2DentaireOpt;
          this.optique =
            TexteGarantiesModels.enumOptiqueOptimum.niveau2OptiqueOpt;
          this.auditif =
            TexteGarantiesModels.enumAuditifOptimum.niveau2AuditifOpt;
        }
        if (codeFormule == 'Formule 3') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinOptimum.niveau3SoinsOpt;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationOptimum.niveau3HospiOpt;
          this.dentaire =
            TexteGarantiesModels.enumDentaireOptimum.niveau3DentaireOpt;
          this.optique =
            TexteGarantiesModels.enumOptiqueOptimum.niveau3OptiqueOpt;
          this.auditif =
            TexteGarantiesModels.enumAuditifOptimum.niveau3AuditifOpt;
        }
        if (codeFormule == 'Formule 4') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinOptimum.niveau4SoinsOpt;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationOptimum.niveau4HospiOpt;
          this.dentaire =
            TexteGarantiesModels.enumDentaireOptimum.niveau4DentaireOpt;
          this.optique =
            TexteGarantiesModels.enumOptiqueOptimum.niveau4OptiqueOpt;
          this.auditif =
            TexteGarantiesModels.enumAuditifOptimum.niveau4AuditifOpt;
        }
        if (codeFormule == 'Formule 5') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinOptimum.niveau5SoinsOpt;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationOptimum.niveau5HospiOpt;
          this.dentaire =
            TexteGarantiesModels.enumDentaireOptimum.niveau5DentaireOpt;
          this.optique =
            TexteGarantiesModels.enumOptiqueOptimum.niveau5OptiqueOpt;
          this.auditif =
            TexteGarantiesModels.enumAuditifOptimum.niveau5AuditifOpt;
        }
        if (codeFormule == 'Formule 6') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinOptimum.niveau6SoinsOpt;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationOptimum.niveau6HospiOpt;
          this.dentaire =
            TexteGarantiesModels.enumDentaireOptimum.niveau6DentaireOpt;
          this.optique =
            TexteGarantiesModels.enumOptiqueOptimum.niveau6OptiqueOpt;
          this.auditif =
            TexteGarantiesModels.enumAuditifOptimum.niveau6AuditifOpt;
        }
        if (codeFormule == 'Formule 7') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinOptimum.niveau7SoinsOpt;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationOptimum.niveau7HospiOpt;
          this.dentaire =
            TexteGarantiesModels.enumDentaireOptimum.niveau7DentaireOpt;
          this.optique =
            TexteGarantiesModels.enumOptiqueOptimum.niveau7OptiqueOpt;
          this.auditif =
            TexteGarantiesModels.enumAuditifOptimum.niveau7AuditifOpt;
        }
        if (codeFormule == 'Formule 8') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinOptimum.niveau8SoinsOpt;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationOptimum.niveau8HospiOpt;
          this.dentaire =
            TexteGarantiesModels.enumDentaireOptimum.niveau8DentaireOpt;
          this.optique =
            TexteGarantiesModels.enumOptiqueOptimum.niveau8OptiqueOpt;
          this.auditif =
            TexteGarantiesModels.enumAuditifOptimum.niveau8AuditifOpt;
        }
        break;
      case TextGarantieCegemaEquilibre.TypeProduitsExistant.CegemaEquilibre:
        this.pointForTypeProduit =
          TextGarantieCegemaEquilibre.enumTexteTypeProduit.typeProduitCegemaEquilibre;

        if (codeFormule == 'N1') {
          this.soinsMedicaux =
            TextGarantieCegemaEquilibre.enumSoinCgEquilibre.niveau1SoinsEquilibre;
          this.hospitalisation =
            TextGarantieCegemaEquilibre.enumHospitalisationCgEquilibre.niveau1HospiEquilibre;
          this.dentaire =
            TextGarantieCegemaEquilibre.enumDentaireCgEquilibre.niveau1DentaireEquilibre;
          this.optique =
            TextGarantieCegemaEquilibre.enumOptiqueCgEquilibre.niveau1OptiqueEquilibre;
          this.auditif =
            TextGarantieCegemaEquilibre.enumAuditifCgEquilibre.niveau1AuditifEquilibre;
        }
        if (codeFormule == 'N2') {
          this.soinsMedicaux =
            TextGarantieCegemaEquilibre.enumSoinCgEquilibre.niveau2SoinsEquilibre;
          this.hospitalisation =
            TextGarantieCegemaEquilibre.enumHospitalisationCgEquilibre.niveau2HospiEquilibre;
          this.dentaire =
            TextGarantieCegemaEquilibre.enumDentaireCgEquilibre.niveau2DentaireEquilibre;
          this.optique =
            TextGarantieCegemaEquilibre.enumOptiqueCgEquilibre.niveau2OptiqueEquilibre;
          this.auditif =
            TextGarantieCegemaEquilibre.enumAuditifCgEquilibre.niveau2AuditifEquilibre;
        }
        if (codeFormule == 'N3') {
          this.soinsMedicaux =
            TextGarantieCegemaEquilibre.enumSoinCgEquilibre.niveau3SoinsEquilibre;
          this.hospitalisation =
            TextGarantieCegemaEquilibre.enumHospitalisationCgEquilibre.niveau3HospiEquilibre;
          this.dentaire =
            TextGarantieCegemaEquilibre.enumDentaireCgEquilibre.niveau3DentaireEquilibre;
          this.optique =
            TextGarantieCegemaEquilibre.enumOptiqueCgEquilibre.niveau3OptiqueEquilibre;
          this.auditif =
            TextGarantieCegemaEquilibre.enumAuditifCgEquilibre.niveau3AuditifEquilibre;
        }
        if (codeFormule == 'N4') {
          this.soinsMedicaux =
            TextGarantieCegemaEquilibre.enumSoinCgEquilibre.niveau4SoinsEquilibre;
          this.hospitalisation =
            TextGarantieCegemaEquilibre.enumHospitalisationCgEquilibre.niveau4HospiEquilibre;
          this.dentaire =
            TextGarantieCegemaEquilibre.enumDentaireCgEquilibre.niveau4DentaireEquilibre;
          this.optique =
            TextGarantieCegemaEquilibre.enumOptiqueCgEquilibre.niveau4OptiqueEquilibre;
          this.auditif =
            TextGarantieCegemaEquilibre.enumAuditifCgEquilibre.niveau4AuditifEquilibre;
        }
        break;
      case TextGarantiekereisSereniteSante.TypeProduitsExistant.KEREIS_SERENITE:
        this.pointForTypeProduit =
          TextGarantiekereisSereniteSante.enumTexteTypeProduit.typeProduitKereisSereniteSante;

        if (codeFormule == 'F1') {
          this.soinsMedicaux =
            TextGarantiekereisSereniteSante.enumSoinKereisSereniteSante.niveau1Soins;
          this.hospitalisation =
            TextGarantiekereisSereniteSante.enumHospitalisationKereisSereniteSante.niveau1Hospi;
          this.dentaire =
            TextGarantiekereisSereniteSante.enumDentaireKereisSereniteSante.niveau1Dentaire;
          this.optique =
            TextGarantiekereisSereniteSante.enumOptiqueKereisSereniteSante.niveau1Optique;
          this.auditif =
            TextGarantiekereisSereniteSante.enumAuditifKereisSereniteSante.niveau1Auditif;
        }
        if (codeFormule == 'F2') {
          this.soinsMedicaux =
            TextGarantiekereisSereniteSante.enumSoinKereisSereniteSante.niveau2Soins;
          this.hospitalisation =
            TextGarantiekereisSereniteSante.enumHospitalisationKereisSereniteSante.niveau2Hospi;
          this.dentaire =
            TextGarantiekereisSereniteSante.enumDentaireKereisSereniteSante.niveau2Dentaire;
          this.optique =
            TextGarantiekereisSereniteSante.enumOptiqueKereisSereniteSante.niveau2Optique;
          this.auditif =
            TextGarantiekereisSereniteSante.enumAuditifKereisSereniteSante.niveau2Auditif;
        }
        if (codeFormule == 'F3') {
          this.soinsMedicaux =
            TextGarantiekereisSereniteSante.enumSoinKereisSereniteSante.niveau3Soins;
          this.hospitalisation =
            TextGarantiekereisSereniteSante.enumHospitalisationKereisSereniteSante.niveau3Hospi;
          this.dentaire =
            TextGarantiekereisSereniteSante.enumDentaireKereisSereniteSante.niveau3Dentaire;
          this.optique =
            TextGarantiekereisSereniteSante.enumOptiqueKereisSereniteSante.niveau3Optique;
          this.auditif =
            TextGarantiekereisSereniteSante.enumAuditifKereisSereniteSante.niveau3Auditif;
        }
        if (codeFormule == 'F4') {
          this.soinsMedicaux =
            TextGarantiekereisSereniteSante.enumSoinKereisSereniteSante.niveau4Soins;
          this.hospitalisation =
            TextGarantiekereisSereniteSante.enumHospitalisationKereisSereniteSante.niveau4Hospi;
          this.dentaire =
            TextGarantiekereisSereniteSante.enumDentaireKereisSereniteSante.niveau4Dentaire;
          this.optique =
            TextGarantiekereisSereniteSante.enumOptiqueKereisSereniteSante.niveau4Optique;
          this.auditif =
            TextGarantiekereisSereniteSante.enumAuditifKereisSereniteSante.niveau4Auditif;
        }
        if (codeFormule == 'F5') {
          this.soinsMedicaux =
            TextGarantiekereisSereniteSante.enumSoinKereisSereniteSante.niveau5Soins;
          this.hospitalisation =
            TextGarantiekereisSereniteSante.enumHospitalisationKereisSereniteSante.niveau5Hospi;
          this.dentaire =
            TextGarantiekereisSereniteSante.enumDentaireKereisSereniteSante.niveau5Dentaire;
          this.optique =
            TextGarantiekereisSereniteSante.enumOptiqueKereisSereniteSante.niveau5Optique;
          this.auditif =
            TextGarantiekereisSereniteSante.enumAuditifKereisSereniteSante.niveau5Auditif;
        }
        if (codeFormule == 'F6') {
          this.soinsMedicaux =
            TextGarantiekereisSereniteSante.enumSoinKereisSereniteSante.niveau6Soins;
          this.hospitalisation =
            TextGarantiekereisSereniteSante.enumHospitalisationKereisSereniteSante.niveau6Hospi;
          this.dentaire =
            TextGarantiekereisSereniteSante.enumDentaireKereisSereniteSante.niveau6Dentaire;
          this.optique =
            TextGarantiekereisSereniteSante.enumOptiqueKereisSereniteSante.niveau6Optique;
          this.auditif =
            TextGarantiekereisSereniteSante.enumAuditifKereisSereniteSante.niveau6Auditif;
        }
        break;
      case TextGarantieCegemaFlexibiliteNR.TypeProduitsExistant.CEGEMA_FLEXI_NR:
        this.pointForTypeProduit =
          TextGarantieCegemaFlexibiliteNR.enumTexteTypeProduit.typeProduitCegemaFlexibilite;

        if (codeFormule.includes('F1')) {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibiliteNR.enumTexteTypeProduit.typeProduitCegemaFlexibilite;

          this.soinsMedicaux =
            TextGarantieCegemaFlexibiliteNR.enumSoinCgFlexibiliteNR.niveau1SoinsFlexibilite;
          this.hospitalisation =
            TextGarantieCegemaFlexibiliteNR.enumHospitalisationCgFlexibiliteNR.niveau1HospiFlexibilite;
          this.dentaire =
            TextGarantieCegemaFlexibiliteNR.enumDentaireCgFlexibiliteNR.niveau1DentaireFlexibilite;
          this.optique =
            TextGarantieCegemaFlexibiliteNR.enumOptiqueCgFlexibiliteNR.niveau1OptiqueFlexibilite;
          this.auditif =
            TextGarantieCegemaFlexibiliteNR.enumAuditifCgFlexibiliteNR.niveau1AuditifFlexibilite;
        }
        if (codeFormule == 'F2') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibiliteNR.enumTexteTypeProduit.typeProduitCegemaFlexibilite;

          this.soinsMedicaux =
            TextGarantieCegemaFlexibiliteNR.enumSoinCgFlexibiliteNR.niveau2SoinsFlexibilite;
          this.hospitalisation =
            TextGarantieCegemaFlexibiliteNR.enumHospitalisationCgFlexibiliteNR.niveau2HospiFlexibilite;
          this.dentaire =
            TextGarantieCegemaFlexibiliteNR.enumDentaireCgFlexibiliteNR.niveau2DentaireFlexibilite;
          this.optique =
            TextGarantieCegemaFlexibiliteNR.enumOptiqueCgFlexibiliteNR.niveau2OptiqueFlexibilite;
          this.auditif =
            TextGarantieCegemaFlexibiliteNR.enumAuditifCgFlexibiliteNR.niveau2AuditifFlexibilite;
        }
        if (codeFormule == 'F3') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibiliteNR.enumTexteTypeProduit.typeProduitCegemaFlexibilite;

          this.soinsMedicaux =
            TextGarantieCegemaFlexibiliteNR.enumSoinCgFlexibiliteNR.niveau3SoinsFlexibilite;
          this.hospitalisation =
            TextGarantieCegemaFlexibiliteNR.enumHospitalisationCgFlexibiliteNR.niveau3HospiFlexibilite;
          this.dentaire =
            TextGarantieCegemaFlexibiliteNR.enumDentaireCgFlexibiliteNR.niveau3DentaireFlexibilite;
          this.optique =
            TextGarantieCegemaFlexibiliteNR.enumOptiqueCgFlexibiliteNR.niveau3OptiqueFlexibilite;
          this.auditif =
            TextGarantieCegemaFlexibiliteNR.enumAuditifCgFlexibiliteNR.niveau3AuditifFlexibilite;
        }
        if (codeFormule == 'F4') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibiliteNR.enumTexteTypeProduit.typeProduitCegemaFlexibilite;

          this.soinsMedicaux =
            TextGarantieCegemaFlexibiliteNR.enumSoinCgFlexibiliteNR.niveau4SoinsFlexibilite;
          this.hospitalisation =
            TextGarantieCegemaFlexibiliteNR.enumHospitalisationCgFlexibiliteNR.niveau4HospiFlexibilite;
          this.dentaire =
            TextGarantieCegemaFlexibiliteNR.enumDentaireCgFlexibiliteNR.niveau4DentaireFlexibilite;
          this.optique =
            TextGarantieCegemaFlexibiliteNR.enumOptiqueCgFlexibiliteNR.niveau4OptiqueFlexibilite;
          this.auditif =
            TextGarantieCegemaFlexibiliteNR.enumAuditifCgFlexibiliteNR.niveau4AuditifFlexibilite;
        }
        if (codeFormule == 'F5') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibiliteNR.enumTexteTypeProduit.typeProduitCegemaFlexibilite;

          this.soinsMedicaux =
            TextGarantieCegemaFlexibiliteNR.enumSoinCgFlexibiliteNR.niveau5SoinsFlexibilite;
          this.hospitalisation =
            TextGarantieCegemaFlexibiliteNR.enumHospitalisationCgFlexibiliteNR.niveau5HospiFlexibilite;
          this.dentaire =
            TextGarantieCegemaFlexibiliteNR.enumDentaireCgFlexibiliteNR.niveau5DentaireFlexibilite;
          this.optique =
            TextGarantieCegemaFlexibiliteNR.enumOptiqueCgFlexibiliteNR.niveau5OptiqueFlexibilite;
          this.auditif =
            TextGarantieCegemaFlexibiliteNR.enumAuditifCgFlexibiliteNR.niveau5AuditifFlexibilite;
        }
        if (codeFormule == 'F6') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibiliteNR.enumTexteTypeProduit.typeProduitCegemaFlexibilite;

          this.soinsMedicaux =
            TextGarantieCegemaFlexibiliteNR.enumSoinCgFlexibiliteNR.niveau6SoinsFlexibilite;
          this.hospitalisation =
            TextGarantieCegemaFlexibiliteNR.enumHospitalisationCgFlexibiliteNR.niveau6HospiFlexibilite;
          this.dentaire =
            TextGarantieCegemaFlexibiliteNR.enumDentaireCgFlexibiliteNR.niveau6DentaireFlexibilite;
          this.optique =
            TextGarantieCegemaFlexibiliteNR.enumOptiqueCgFlexibiliteNR.niveau6OptiqueFlexibilite;
          this.auditif =
            TextGarantieCegemaFlexibiliteNR.enumAuditifCgFlexibiliteNR.niveau6AuditifFlexibilite;
        }

        if (codeFormule == 'F2 ECO MALIN') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibiliteNR.enumTexteTypeProduit.typeProduitCegemaFlexibiliteEcoMalin;

          this.soinsMedicaux =
            TextGarantieCegemaFlexibiliteNR.enumSoinCgFlexibiliteNR.niveau2SoinsFlexibiliteEcoMalin;
          this.hospitalisation =
            TextGarantieCegemaFlexibiliteNR.enumHospitalisationCgFlexibiliteNR.niveau2HospiFlexibiliteEcoMalin;
          this.dentaire =
            TextGarantieCegemaFlexibiliteNR.enumDentaireCgFlexibiliteNR.niveau2DentaireFlexibiliteEcoMalin;
          this.optique =
            TextGarantieCegemaFlexibiliteNR.enumOptiqueCgFlexibiliteNR.niveau2OptiqueFlexibiliteEcoMalin;
          this.auditif =
            TextGarantieCegemaFlexibiliteNR.enumAuditifCgFlexibiliteNR.niveau2AuditifFlexibiliteEcoMalin;
        }
        if (codeFormule == 'F3 ECO MALIN') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibiliteNR.enumTexteTypeProduit.typeProduitCegemaFlexibiliteEcoMalin;
          this.soinsMedicaux =
            TextGarantieCegemaFlexibiliteNR.enumSoinCgFlexibiliteNR.niveau3SoinsFlexibiliteEcoMalin;
          this.hospitalisation =
            TextGarantieCegemaFlexibiliteNR.enumHospitalisationCgFlexibiliteNR.niveau3HospiFlexibiliteEcoMalin;
          this.dentaire =
            TextGarantieCegemaFlexibiliteNR.enumDentaireCgFlexibiliteNR.niveau3DentaireFlexibiliteEcoMalin;
          this.optique =
            TextGarantieCegemaFlexibiliteNR.enumOptiqueCgFlexibiliteNR.niveau3OptiqueFlexibiliteEcoMalin;
          this.auditif =
            TextGarantieCegemaFlexibiliteNR.enumAuditifCgFlexibiliteNR.niveau3AuditifFlexibiliteEcoMalin;
        }
        if (codeFormule == 'F4 ECO MALIN') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibiliteNR.enumTexteTypeProduit.typeProduitCegemaFlexibiliteEcoMalin;
          this.soinsMedicaux =
            TextGarantieCegemaFlexibiliteNR.enumSoinCgFlexibiliteNR.niveau4SoinsFlexibiliteEcoMalin;
          this.hospitalisation =
            TextGarantieCegemaFlexibiliteNR.enumHospitalisationCgFlexibiliteNR.niveau4HospiFlexibiliteEcoMalin;
          this.dentaire =
            TextGarantieCegemaFlexibiliteNR.enumDentaireCgFlexibiliteNR.niveau4DentaireFlexibiliteEcoMalin;
          this.optique =
            TextGarantieCegemaFlexibiliteNR.enumOptiqueCgFlexibiliteNR.niveau4OptiqueFlexibiliteEcoMalin;
          this.auditif =
            TextGarantieCegemaFlexibiliteNR.enumAuditifCgFlexibiliteNR.niveau4AuditifFlexibiliteEcoMalin;
        }
        if (codeFormule == 'F5 ECO MALIN') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibiliteNR.enumTexteTypeProduit.typeProduitCegemaFlexibiliteEcoMalin;
          this.soinsMedicaux =
            TextGarantieCegemaFlexibiliteNR.enumSoinCgFlexibiliteNR.niveau5SoinsFlexibiliteEcoMalin;
          this.hospitalisation =
            TextGarantieCegemaFlexibiliteNR.enumHospitalisationCgFlexibiliteNR.niveau5HospiFlexibiliteEcoMalin;
          this.dentaire =
            TextGarantieCegemaFlexibiliteNR.enumDentaireCgFlexibiliteNR.niveau5DentaireFlexibiliteEcoMalin;
          this.optique =
            TextGarantieCegemaFlexibiliteNR.enumOptiqueCgFlexibiliteNR.niveau5OptiqueFlexibiliteEcoMalin;
          this.auditif =
            TextGarantieCegemaFlexibiliteNR.enumAuditifCgFlexibiliteNR.niveau5AuditifFlexibiliteEcoMalin;
        }
        if (codeFormule == 'F6 ECO MALIN') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibiliteNR.enumTexteTypeProduit.typeProduitCegemaFlexibiliteEcoMalin;
          this.soinsMedicaux =
            TextGarantieCegemaFlexibiliteNR.enumSoinCgFlexibiliteNR.niveau6SoinsFlexibiliteEcoMalin;
          this.hospitalisation =
            TextGarantieCegemaFlexibiliteNR.enumHospitalisationCgFlexibiliteNR.niveau6HospiFlexibiliteEcoMalin;
          this.dentaire =
            TextGarantieCegemaFlexibiliteNR.enumDentaireCgFlexibiliteNR.niveau6DentaireFlexibiliteEcoMalin;
          this.optique =
            TextGarantieCegemaFlexibiliteNR.enumOptiqueCgFlexibiliteNR.niveau6OptiqueFlexibiliteEcoMalin;
          this.auditif =
            TextGarantieCegemaFlexibiliteNR.enumAuditifCgFlexibiliteNR.niveau6AuditifFlexibiliteEcoMalin;
        }

        break;
      case TextGarantieCegemaFlexibilite100Sante.TypeProduitsExistant
        .CEGEMA_FLEXI_100_SANTE:
        if (codeFormule.includes('F1')) {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibilite100Sante.enumTexteTypeProduit.typeProduitCegemaFlexibilite;
          this.soinsMedicaux =
            TextGarantieCegemaFlexibilite100Sante.enumSoinCgFlexibilite100Sante.niveau1SoinsFlexibilite;
          this.hospitalisation =
            TextGarantieCegemaFlexibilite100Sante.enumHospitalisationCgFlexibilite100Sante.niveau1HospiFlexibilite;
          this.dentaire =
            TextGarantieCegemaFlexibilite100Sante.enumDentaireCgFlexibilite100Sante.niveau1DentaireFlexibilite;
          this.optique =
            TextGarantieCegemaFlexibilite100Sante.enumOptiqueCgFlexibilite100Sante.niveau1OptiqueFlexibilite;
          this.auditif =
            TextGarantieCegemaFlexibilite100Sante.enumAuditifCgFlexibilite100Sante.niveau1AuditifFlexibilite;
        }
        if (codeFormule == 'F2') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibilite100Sante.enumTexteTypeProduit.typeProduitCegemaFlexibilite;
          this.soinsMedicaux =
            TextGarantieCegemaFlexibilite100Sante.enumSoinCgFlexibilite100Sante.niveau2SoinsFlexibilite;
          this.hospitalisation =
            TextGarantieCegemaFlexibilite100Sante.enumHospitalisationCgFlexibilite100Sante.niveau2HospiFlexibilite;
          this.dentaire =
            TextGarantieCegemaFlexibilite100Sante.enumDentaireCgFlexibilite100Sante.niveau2DentaireFlexibilite;
          this.optique =
            TextGarantieCegemaFlexibilite100Sante.enumOptiqueCgFlexibilite100Sante.niveau2OptiqueFlexibilite;
          this.auditif =
            TextGarantieCegemaFlexibilite100Sante.enumAuditifCgFlexibilite100Sante.niveau2AuditifFlexibilite;
        }
        if (codeFormule == 'F3') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibilite100Sante.enumTexteTypeProduit.typeProduitCegemaFlexibilite;
          this.soinsMedicaux =
            TextGarantieCegemaFlexibilite100Sante.enumSoinCgFlexibilite100Sante.niveau3SoinsFlexibilite;
          this.hospitalisation =
            TextGarantieCegemaFlexibilite100Sante.enumHospitalisationCgFlexibilite100Sante.niveau3HospiFlexibilite;
          this.dentaire =
            TextGarantieCegemaFlexibilite100Sante.enumDentaireCgFlexibilite100Sante.niveau3DentaireFlexibilite;
          this.optique =
            TextGarantieCegemaFlexibilite100Sante.enumOptiqueCgFlexibilite100Sante.niveau3OptiqueFlexibilite;
          this.auditif =
            TextGarantieCegemaFlexibilite100Sante.enumAuditifCgFlexibilite100Sante.niveau3AuditifFlexibilite;
        }
        if (codeFormule == 'F4') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibilite100Sante.enumTexteTypeProduit.typeProduitCegemaFlexibilite;
          this.soinsMedicaux =
            TextGarantieCegemaFlexibilite100Sante.enumSoinCgFlexibilite100Sante.niveau4SoinsFlexibilite;
          this.hospitalisation =
            TextGarantieCegemaFlexibilite100Sante.enumHospitalisationCgFlexibilite100Sante.niveau4HospiFlexibilite;
          this.dentaire =
            TextGarantieCegemaFlexibilite100Sante.enumDentaireCgFlexibilite100Sante.niveau4DentaireFlexibilite;
          this.optique =
            TextGarantieCegemaFlexibilite100Sante.enumOptiqueCgFlexibilite100Sante.niveau4OptiqueFlexibilite;
          this.auditif =
            TextGarantieCegemaFlexibilite100Sante.enumAuditifCgFlexibilite100Sante.niveau4AuditifFlexibilite;
        }
        if (codeFormule == 'F5') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibilite100Sante.enumTexteTypeProduit.typeProduitCegemaFlexibilite;
          this.soinsMedicaux =
            TextGarantieCegemaFlexibilite100Sante.enumSoinCgFlexibilite100Sante.niveau5SoinsFlexibilite;
          this.hospitalisation =
            TextGarantieCegemaFlexibilite100Sante.enumHospitalisationCgFlexibilite100Sante.niveau5HospiFlexibilite;
          this.dentaire =
            TextGarantieCegemaFlexibilite100Sante.enumDentaireCgFlexibilite100Sante.niveau5DentaireFlexibilite;
          this.optique =
            TextGarantieCegemaFlexibilite100Sante.enumOptiqueCgFlexibilite100Sante.niveau5OptiqueFlexibilite;
          this.auditif =
            TextGarantieCegemaFlexibilite100Sante.enumAuditifCgFlexibilite100Sante.niveau5AuditifFlexibilite;
        }
        if (codeFormule == 'F6') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibilite100Sante.enumTexteTypeProduit.typeProduitCegemaFlexibilite;
          this.soinsMedicaux =
            TextGarantieCegemaFlexibilite100Sante.enumSoinCgFlexibilite100Sante.niveau6SoinsFlexibilite;
          this.hospitalisation =
            TextGarantieCegemaFlexibilite100Sante.enumHospitalisationCgFlexibilite100Sante.niveau6HospiFlexibilite;
          this.dentaire =
            TextGarantieCegemaFlexibilite100Sante.enumDentaireCgFlexibilite100Sante.niveau6DentaireFlexibilite;
          this.optique =
            TextGarantieCegemaFlexibilite100Sante.enumOptiqueCgFlexibilite100Sante.niveau6OptiqueFlexibilite;
          this.auditif =
            TextGarantieCegemaFlexibilite100Sante.enumAuditifCgFlexibilite100Sante.niveau6AuditifFlexibilite;
        }

        if (codeFormule == 'F2 ECO MALIN') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibilite100Sante.enumTexteTypeProduit.typeProduitCegemaFlexibiliteEcoMalin;
          this.soinsMedicaux =
            TextGarantieCegemaFlexibilite100Sante.enumSoinCgFlexibilite100Sante.niveau2SoinsFlexibiliteEcoMalin;
          this.hospitalisation =
            TextGarantieCegemaFlexibilite100Sante.enumHospitalisationCgFlexibilite100Sante.niveau2HospiFlexibiliteEcoMalin;
          this.dentaire =
            TextGarantieCegemaFlexibilite100Sante.enumDentaireCgFlexibilite100Sante.niveau2DentaireFlexibiliteEcoMalin;
          this.optique =
            TextGarantieCegemaFlexibilite100Sante.enumOptiqueCgFlexibilite100Sante.niveau2OptiqueFlexibiliteEcoMalin;
          this.auditif =
            TextGarantieCegemaFlexibilite100Sante.enumAuditifCgFlexibilite100Sante.niveau2AuditifFlexibiliteEcoMalin;
        }
        if (codeFormule == 'F3 ECO MALIN') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibilite100Sante.enumTexteTypeProduit.typeProduitCegemaFlexibiliteEcoMalin;
          this.soinsMedicaux =
            TextGarantieCegemaFlexibilite100Sante.enumSoinCgFlexibilite100Sante.niveau3SoinsFlexibiliteEcoMalin;
          this.hospitalisation =
            TextGarantieCegemaFlexibilite100Sante.enumHospitalisationCgFlexibilite100Sante.niveau3HospiFlexibiliteEcoMalin;
          this.dentaire =
            TextGarantieCegemaFlexibilite100Sante.enumDentaireCgFlexibilite100Sante.niveau3DentaireFlexibiliteEcoMalin;
          this.optique =
            TextGarantieCegemaFlexibilite100Sante.enumOptiqueCgFlexibilite100Sante.niveau3OptiqueFlexibiliteEcoMalin;
          this.auditif =
            TextGarantieCegemaFlexibilite100Sante.enumAuditifCgFlexibilite100Sante.niveau3AuditifFlexibiliteEcoMalin;
        }
        if (codeFormule == 'F4 ECO MALIN') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibilite100Sante.enumTexteTypeProduit.typeProduitCegemaFlexibiliteEcoMalin;
          this.soinsMedicaux =
            TextGarantieCegemaFlexibilite100Sante.enumSoinCgFlexibilite100Sante.niveau4SoinsFlexibiliteEcoMalin;
          this.hospitalisation =
            TextGarantieCegemaFlexibilite100Sante.enumHospitalisationCgFlexibilite100Sante.niveau4HospiFlexibiliteEcoMalin;
          this.dentaire =
            TextGarantieCegemaFlexibilite100Sante.enumDentaireCgFlexibilite100Sante.niveau4DentaireFlexibiliteEcoMalin;
          this.optique =
            TextGarantieCegemaFlexibilite100Sante.enumOptiqueCgFlexibilite100Sante.niveau4OptiqueFlexibiliteEcoMalin;
          this.auditif =
            TextGarantieCegemaFlexibilite100Sante.enumAuditifCgFlexibilite100Sante.niveau4AuditifFlexibiliteEcoMalin;
        }
        if (codeFormule == 'F5 ECO MALIN') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibilite100Sante.enumTexteTypeProduit.typeProduitCegemaFlexibiliteEcoMalin;
          this.soinsMedicaux =
            TextGarantieCegemaFlexibilite100Sante.enumSoinCgFlexibilite100Sante.niveau5SoinsFlexibiliteEcoMalin;
          this.hospitalisation =
            TextGarantieCegemaFlexibilite100Sante.enumHospitalisationCgFlexibilite100Sante.niveau5HospiFlexibiliteEcoMalin;
          this.dentaire =
            TextGarantieCegemaFlexibilite100Sante.enumDentaireCgFlexibilite100Sante.niveau5DentaireFlexibiliteEcoMalin;
          this.optique =
            TextGarantieCegemaFlexibilite100Sante.enumOptiqueCgFlexibilite100Sante.niveau5OptiqueFlexibiliteEcoMalin;
          this.auditif =
            TextGarantieCegemaFlexibilite100Sante.enumAuditifCgFlexibilite100Sante.niveau5AuditifFlexibiliteEcoMalin;
        }
        if (codeFormule == 'F6 ECO MALIN') {
          this.pointForTypeProduit =
            TextGarantieCegemaFlexibilite100Sante.enumTexteTypeProduit.typeProduitCegemaFlexibiliteEcoMalin;
          this.soinsMedicaux =
            TextGarantieCegemaFlexibilite100Sante.enumSoinCgFlexibilite100Sante.niveau6SoinsFlexibiliteEcoMalin;
          this.hospitalisation =
            TextGarantieCegemaFlexibilite100Sante.enumHospitalisationCgFlexibilite100Sante.niveau6HospiFlexibiliteEcoMalin;
          this.dentaire =
            TextGarantieCegemaFlexibilite100Sante.enumDentaireCgFlexibilite100Sante.niveau6DentaireFlexibiliteEcoMalin;
          this.optique =
            TextGarantieCegemaFlexibilite100Sante.enumOptiqueCgFlexibilite100Sante.niveau6OptiqueFlexibiliteEcoMalin;
          this.auditif =
            TextGarantieCegemaFlexibilite100Sante.enumAuditifCgFlexibilite100Sante.niveau6AuditifFlexibiliteEcoMalin;
        }
        break;
      case TexteGarantiesModels.TypeProduitsExistant.ProgressionSanteFamille:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitProgressionSante;

        if (codeFormule == 'Formule 1') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteFamille.niveau1SoinsProgSanteFamille;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteFamille.niveau1HospiProgSanteFamille;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteFamille.niveau1DentaireProgSanteFamille;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteFamille.niveau1OptiqueProgSanteFamille;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteFamille.niveau1AuditifProgSanteFamille;
        }
        if (codeFormule == 'Formule 2') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteFamille.niveau2SoinsProgSanteFamille;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteFamille.niveau2HospiProgSanteFamille;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteFamille.niveau2DentaireProgSanteFamille;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteFamille.niveau2OptiqueProgSanteFamille;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteFamille.niveau2AuditifProgSanteFamille;
        }
        if (codeFormule == 'Formule 3') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteFamille.niveau3SoinsProgSanteFamille;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteFamille.niveau3HospiProgSanteFamille;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteFamille.niveau3DentaireProgSanteFamille;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteFamille.niveau3OptiqueProgSanteFamille;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteFamille.niveau3AuditifProgSanteFamille;
        }
        if (codeFormule == 'Formule 4') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteFamille.niveau4SoinsProgSanteFamille;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteFamille.niveau4HospiProgSanteFamille;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteFamille.niveau4DentaireProgSanteFamille;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteFamille.niveau4OptiqueProgSanteFamille;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteFamille.niveau4AuditifProgSanteFamille;
        }
        if (codeFormule == 'Formule 5') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteFamille.niveau5SoinsProgSanteFamille;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteFamille.niveau5HospiProgSanteFamille;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteFamille.niveau5DentaireProgSanteFamille;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteFamille.niveau5OptiqueProgSanteFamille;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteFamille.niveau5AuditifProgSanteFamille;
        }
        if (codeFormule == 'Formule 6') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteFamille.niveau6SoinsProgSanteFamille;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteFamille.niveau6HospiProgSanteFamille;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteFamille.niveau6DentaireProgSanteFamille;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteFamille.niveau6OptiqueProgSanteFamille;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteFamille.niveau6AuditifProgSanteFamille;
        }
        if (codeFormule == 'Formule 7') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteFamille.niveau7SoinsProgSanteFamille;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteFamille.niveau7HospiProgSanteFamille;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteFamille.niveau7DentaireProgSanteFamille;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteFamille.niveau7OptiqueProgSanteFamille;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteFamille.niveau7AuditifProgSanteFamille;
        }
        if (codeFormule == 'Formule 8') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteFamille.niveau8SoinsProgSanteFamille;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteFamille.niveau8HospiProgSanteFamille;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteFamille.niveau8DentaireProgSanteFamille;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteFamille.niveau8OptiqueProgSanteFamille;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteFamille.niveau8AuditifProgSanteFamille;
        }
        if (codeFormule == 'Formule 9') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteFamille.niveau9SoinsProgSanteFamille;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteFamille.niveau9HospiProgSanteFamille;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteFamille.niveau9DentaireProgSanteFamille;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteFamille.niveau9OptiqueProgSanteFamille;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteFamille.niveau9AuditifProgSanteFamille;
        }
        if (codeFormule == 'Formule 10') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteFamille.niveau10SoinsProgSanteFamille;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteFamille.niveau10HospiProgSanteFamille;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteFamille.niveau10DentaireProgSanteFamille;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteFamille.niveau10OptiqueProgSanteFamille;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteFamille.niveau10AuditifProgSanteFamille;
        }
        if (codeFormule == 'Formule 11') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteFamille.niveau11SoinsProgSanteFamille;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteFamille.niveau11HospiProgSanteFamille;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteFamille.niveau11DentaireProgSanteFamille;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteFamille.niveau11OptiqueProgSanteFamille;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteFamille.niveau11AuditifProgSanteFamille;
        }
        if (codeFormule == 'Formule 12') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteFamille.niveau12SoinsProgSanteFamille;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteFamille.niveau12HospiProgSanteFamille;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteFamille.niveau12DentaireProgSanteFamille;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteFamille.niveau12OptiqueProgSanteFamille;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteFamille.niveau12AuditifProgSanteFamille;
        }
        break;
      case TexteGarantiesModels.TypeProduitsExistant.ProgressionSanteSenior:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitProgressionSante;

        if (codeFormule == 'Formule 1') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteSenior.niveau1SoinsProgSanteSenior;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteSenior.niveau1HospiProgSanteSenior;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteSenior.niveau1DentaireProgSanteSenior;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteSenior.niveau1OptiqueProgSanteSenior;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteSenior.niveau1AuditifProgSanteSenior;
        }
        if (codeFormule == 'Formule 2') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteSenior.niveau2SoinsProgSanteSenior;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteSenior.niveau2HospiProgSanteSenior;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteSenior.niveau2DentaireProgSanteSenior;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteSenior.niveau2OptiqueProgSanteSenior;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteSenior.niveau2AuditifProgSanteSenior;
        }
        if (codeFormule == 'Formule 3') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteSenior.niveau3SoinsProgSanteSenior;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteSenior.niveau3HospiProgSanteSenior;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteSenior.niveau3DentaireProgSanteSenior;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteSenior.niveau3OptiqueProgSanteSenior;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteSenior.niveau3AuditifProgSanteSenior;
        }
        if (codeFormule == 'Formule 4') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteSenior.niveau4SoinsProgSanteSenior;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteSenior.niveau4HospiProgSanteSenior;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteSenior.niveau4DentaireProgSanteSenior;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteSenior.niveau4OptiqueProgSanteSenior;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteSenior.niveau4AuditifProgSanteSenior;
        }
        if (codeFormule == 'Formule 5') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteSenior.niveau5SoinsProgSanteSenior;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteSenior.niveau5HospiProgSanteSenior;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteSenior.niveau5DentaireProgSanteSenior;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteSenior.niveau5OptiqueProgSanteSenior;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteSenior.niveau5AuditifProgSanteSenior;
        }
        if (codeFormule == 'Formule 6') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteSenior.niveau6SoinsProgSanteSenior;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteSenior.niveau6HospiProgSanteSenior;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteSenior.niveau6DentaireProgSanteSenior;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteSenior.niveau6OptiqueProgSanteSenior;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteSenior.niveau6AuditifProgSanteSenior;
        }
        if (codeFormule == 'Formule 7') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteSenior.niveau7SoinsProgSanteSenior;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteSenior.niveau7HospiProgSanteSenior;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteSenior.niveau7DentaireProgSanteSenior;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteSenior.niveau7OptiqueProgSanteSenior;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteSenior.niveau7AuditifProgSanteSenior;
        }
        if (codeFormule == 'Formule 8') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteSenior.niveau8SoinsProgSanteSenior;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteSenior.niveau8HospiProgSanteSenior;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteSenior.niveau8DentaireProgSanteSenior;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteSenior.niveau8OptiqueProgSanteSenior;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteSenior.niveau8AuditifProgSanteSenior;
        }
        if (codeFormule == 'Formule 9') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteSenior.niveau9SoinsProgSanteSenior;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteSenior.niveau9HospiProgSanteSenior;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteSenior.niveau9DentaireProgSanteSenior;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteSenior.niveau9OptiqueProgSanteSenior;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteSenior.niveau9AuditifProgSanteSenior;
        }
        if (codeFormule == 'Formule 10') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteSenior.niveau10SoinsProgSanteSenior;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteSenior.niveau10HospiProgSanteSenior;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteSenior.niveau10DentaireProgSanteSenior;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteSenior.niveau10OptiqueProgSanteSenior;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteSenior.niveau10AuditifProgSanteSenior;
        }
        if (codeFormule == 'Formule 11') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteSenior.niveau11SoinsProgSanteSenior;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteSenior.niveau11HospiProgSanteSenior;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteSenior.niveau11DentaireProgSanteSenior;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteSenior.niveau11OptiqueProgSanteSenior;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteSenior.niveau11AuditifProgSanteSenior;
        }
        if (codeFormule == 'Formule 12') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinProgSanteSenior.niveau12SoinsProgSanteSenior;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationProgSanteSenior.niveau12HospiProgSanteSenior;
          this.dentaire =
            TexteGarantiesModels.enumDentaireProgSanteSenior.niveau12DentaireProgSanteSenior;
          this.optique =
            TexteGarantiesModels.enumOptiqueProgSanteSenior.niveau12OptiqueProgSanteSenior;
          this.auditif =
            TexteGarantiesModels.enumAuditifProgSanteSenior.niveau12AuditifProgSanteSenior;
        }
        break;
      case TextGarantieModelSpvie.TypeProduitsExistant.SpvieSanteNova:
        this.pointForTypeProduit =
          TextGarantieModelSpvie.enumTexteTypeProduit.tpSpvieSanteNova;

        if (codeFormule == 'Niveau A') {
          this.soinsMedicaux =
            TextGarantieModelSpvie.enumSoinNova.niveauASoinsNova;
          this.hospitalisation =
            TextGarantieModelSpvie.enumHospitalisationNova.niveauAHospiNova;
          this.dentaire =
            TextGarantieModelSpvie.enumDentaireNova.niveauADentaireNova;
          this.optique =
            TextGarantieModelSpvie.enumOptiqueNova.niveauAOptiqueNova;
          this.auditif =
            TextGarantieModelSpvie.enumAuditifNova.niveauAAuditifNova;
        }
        if (codeFormule == 'Niveau B') {
          this.soinsMedicaux =
            TextGarantieModelSpvie.enumSoinNova.niveauBSoinsNova;
          this.hospitalisation =
            TextGarantieModelSpvie.enumHospitalisationNova.niveauBHospiNova;
          this.dentaire =
            TextGarantieModelSpvie.enumDentaireNova.niveauBDentaireNova;
          this.optique =
            TextGarantieModelSpvie.enumOptiqueNova.niveauBOptiqueNova;
          this.auditif =
            TextGarantieModelSpvie.enumAuditifNova.niveauBAuditifNova;
        }
        if (codeFormule == 'Niveau C') {
          this.soinsMedicaux =
            TextGarantieModelSpvie.enumSoinNova.niveauCSoinsNova;
          this.hospitalisation =
            TextGarantieModelSpvie.enumHospitalisationNova.niveauCHospiNova;
          this.dentaire =
            TextGarantieModelSpvie.enumDentaireNova.niveauCDentaireNova;
          this.optique =
            TextGarantieModelSpvie.enumOptiqueNova.niveauCOptiqueNova;
          this.auditif =
            TextGarantieModelSpvie.enumAuditifNova.niveauCAuditifNova;
        }
        if (codeFormule == 'Niveau D') {
          this.soinsMedicaux =
            TextGarantieModelSpvie.enumSoinNova.niveauDSoinsNova;
          this.hospitalisation =
            TextGarantieModelSpvie.enumHospitalisationNova.niveauDHospiNova;
          this.dentaire =
            TextGarantieModelSpvie.enumDentaireNova.niveauDDentaireNova;
          this.optique =
            TextGarantieModelSpvie.enumOptiqueNova.niveauDOptiqueNova;
          this.auditif =
            TextGarantieModelSpvie.enumAuditifNova.niveauDAuditifNova;
        }
        if (codeFormule == 'Niveau E') {
          this.soinsMedicaux =
            TextGarantieModelSpvie.enumSoinNova.niveauESoinsNova;
          this.hospitalisation =
            TextGarantieModelSpvie.enumHospitalisationNova.niveauEHospiNova;
          this.dentaire =
            TextGarantieModelSpvie.enumDentaireNova.niveauEDentaireNova;
          this.optique =
            TextGarantieModelSpvie.enumOptiqueNova.niveauEOptiqueNova;
          this.auditif =
            TextGarantieModelSpvie.enumAuditifNova.niveauEAuditifNova;
        }
        break;
      case TextGarantieMtxVita.TypeProduitsExistant.MtxVitaFamilleNr:
        this.pointForTypeProduit =
          TextGarantieMtxVita.enumTexteTypeProduit.tpMtxVitaSante;

        const garantieNiveau = NiveauxGarantieMtxVitaFamille[codeFormule];
        if (garantieNiveau) {
          this.soinsMedicaux = garantieNiveau.soinsMedicaux;
          this.hospitalisation = garantieNiveau.hospitalisation;
          this.dentaire = garantieNiveau.dentaire;
          this.optique = garantieNiveau.optique;
          this.auditif = garantieNiveau.auditif;
        }
        break;
      case TextGarantieMtxVita.TypeProduitsExistant.MtxVitaPlus55Nr:
        this.pointForTypeProduit =
          TextGarantieMtxVita.enumTexteTypeProduit.tpMtxVitaSante;

        const garantieNiveau55Plus = NiveauxGarantieMtxVita55Plus[codeFormule];
        if (garantieNiveau55Plus) {
          this.soinsMedicaux = garantieNiveau55Plus.soinsMedicaux;
          this.hospitalisation = garantieNiveau55Plus.hospitalisation;
          this.dentaire = garantieNiveau55Plus.dentaire;
          this.optique = garantieNiveau55Plus.optique;
          this.auditif = garantieNiveau55Plus.auditif;
        }
        break;
      //*** ESSENTIEL PLUS SANTE ***/
      case TexteGarantiesModels.TypeProduitsExistant.EssentielPlusSante:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitEssentielPlusSante;

        if (codeFormule?.toLowerCase() == 'niveau 1') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinEssentielPlusSante.niveau1SoinsEssentielPlusSante;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielPlusSante.niveau1HospiEssentielPlusSante;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielPlusSante.niveau1DentaireEssentielPlusSante;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielPlusSante.niveau1OptiqueEssentielPlusSante;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielPlusSante.niveau1AuditifEssentielPlusSante;
        }
        if (codeFormule?.toLowerCase() == 'niveau 2') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinEssentielPlusSante.niveau2SoinsEssentielPlusSante;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielPlusSante.niveau2HospiEssentielPlusSante;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielPlusSante.niveau2DentaireEssentielPlusSante;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielPlusSante.niveau2OptiqueEssentielPlusSante;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielPlusSante.niveau2AuditifEssentielPlusSante;
        }
        if (codeFormule?.toLowerCase() == 'niveau 3') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinEssentielPlusSante.niveau3SoinsEssentielPlusSante;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielPlusSante.niveau3HospiEssentielPlusSante;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielPlusSante.niveau3DentaireEssentielPlusSante;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielPlusSante.niveau3OptiqueEssentielPlusSante;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielPlusSante.niveau3AuditifEssentielPlusSante;
        }
        if (codeFormule?.toLowerCase() == 'niveau 4') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinEssentielPlusSante.niveau4SoinsEssentielPlusSante;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielPlusSante.niveau4HospiEssentielPlusSante;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielPlusSante.niveau4DentaireEssentielPlusSante;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielPlusSante.niveau4OptiqueEssentielPlusSante;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielPlusSante.niveau4AuditifEssentielPlusSante;
        }
        break;

      case TexteGarantiesModels.TypeProduitsExistant.EssentielPlusSanteEco:
        this.pointForTypeProduit =
          TexteGarantiesModels.enumTexteTypeproduit.typeProduitEssentielPlusSante;

        if (codeFormule?.toLowerCase() == 'niveau 1') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinEssentielPlusSanteEco.niveau1SoinsEssentielPlusSanteEco;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielPlusSanteEco.niveau1HospiEssentielPlusSanteEco;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielPlusSanteEco.niveau1DentaireEssentielPlusSanteEco;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielPlusSanteEco.niveau1OptiqueEssentielPlusSanteEco;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielPlusSanteEco.niveau1AuditifEssentielPlusSanteEco;
        }
        if (codeFormule?.toLowerCase() == 'niveau 2') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinEssentielPlusSanteEco.niveau2SoinsEssentielPlusSanteEco;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielPlusSanteEco.niveau2HospiEssentielPlusSanteEco;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielPlusSanteEco.niveau2DentaireEssentielPlusSanteEco;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielPlusSanteEco.niveau2OptiqueEssentielPlusSanteEco;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielPlusSanteEco.niveau2AuditifEssentielPlusSanteEco;
        }
        if (codeFormule?.toLowerCase() == 'niveau 3') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinEssentielPlusSanteEco.niveau3SoinsEssentielPlusSanteEco;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielPlusSanteEco.niveau3HospiEssentielPlusSanteEco;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielPlusSanteEco.niveau3DentaireEssentielPlusSanteEco;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielPlusSanteEco.niveau3OptiqueEssentielPlusSanteEco;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielPlusSanteEco.niveau3AuditifEssentielPlusSanteEco;
        }
        if (codeFormule?.toLowerCase() == 'niveau 4') {
          this.soinsMedicaux =
            TexteGarantiesModels.enumSoinEssentielPlusSanteEco.niveau4SoinsEssentielPlusSanteEco;
          this.hospitalisation =
            TexteGarantiesModels.enumHospitalisationEssentielPlusSanteEco.niveau4HospiEssentielPlusSanteEco;
          this.dentaire =
            TexteGarantiesModels.enumDentaireEssentielPlusSanteEco.niveau4DentaireEssentielPlusSanteEco;
          this.optique =
            TexteGarantiesModels.enumOptiqueEssentielPlusSanteEco.niveau4OptiqueEssentielPlusSanteEco;
          this.auditif =
            TexteGarantiesModels.enumAuditifEssentielPlusSanteEco.niveau4AuditifEssentielPlusSanteEco;
        }
        break;
      default:
        break;
    }
  }

  //Receive infos personne from filtre offre Modal
  receiveInfosPersonne(event: any) {
    this.defaultcontrolListeParam = event;
    //recuperation leadID à mettre à jour
    sessionStorage.setItem(
      'app.lead',
      JSON.stringify(this.formulesAfi[0].lead_id),
    );
    let leadId: any = sessionStorage.getItem('app.lead');
    //Update quotaion form
    this.quotationForm.assureInfos.nom = this.personne.nom;
    this.quotationForm.assureInfos.prenom = this.personne.prenom;
    this.quotationForm.assurePrincipal.regimeSocial = Number.parseInt(
      this.personne.regimeSocial,
    );
    this.quotationForm.assurePrincipal.dateNaissance =
      this.personne.dateNaissanceAssure;
    this.quotationForm.assurePrincipal.dateEffet =
      this.personne.dateDebutContrat;
    this.quotationForm.vadInfo.tarifier = 'oui_init_Avenant';
    this.quotationForm.vadInfo.leadId = JSON.parse(leadId);
    this.refreshPricingsAsync();
  }

  infos!: any;
  assure!: any;
  universBesoinQuestionResponse!: any;
  family!: HealthModels.Family;

  initialize() {
    this.storedData = this.healthInsuranceService.getStoredData();

    // debugger; // utile
    if (this.storedData.quotationForm.assureInfos != null) {
      //Des fois assureInfos c'est null??

      this.quotationForm = this.storedData.quotationForm;
      this.defaultBrokerFees = this.storedData.brokerFees;
      this.defaultcontrolListeParam = this.storedData.controlListeParam;
      this.defaultFormulaChoice = this.storedData.formulaChoice;
      this.currentStaggering = this.storedData.currentStaggering;
      this.package = this.storedData.package;
    }
    //Ecraser les données fake ou null:
    else {
      const Addresse = {
        streetName: 'les Bosquets de Chambéry',
        streetNumber: 12,
        streetType: 'Lotissement',
        repetition: 'string',
        complement: 'string',
        cityName: 'Ivry-sur-Seine',
        cityZipCode: this.personne.codePostal,
        codeInsee: '94041',
      };
      this.infos = {
        civilite: this.personne.sexe,
        nom: this.personne.nom,
        prenom: this.personne.prenom,
        address: Addresse,
        email: this.personne.email,
        phone: this.personne.telephone,
        mobile: this.personne.telephone,
        immatriculation: '4511211',

        birthPlace: 'Paris ',
        birthCountry: 'France',
        doAgreeToReceiveInfosByEmail: false,
        isPoliticallyExposed: false,
        isEntournagePoliticallyExposed: false,
        doCertify: false,
      };
      const groupeville = {
        codePostal: this.personne.codePostal,
        ville: 'Ivry-sur-Seine',
        inseeCode: '94041',
      };
      this.assure = {
        groupVille: groupeville,
        dateNaissance: this.personne.dateNaissanceAssure,
        dateEffet: this.personne.dateDebutContrat,
        regimeSocial: this.personne.regimeSocial,
      };
      this.universBesoinQuestionResponse = {
        type: 1,
        level: 2,
      };
      this.family = {
        conjoint: {
          dateNaissance: this.personne.dateNaissanceConjoint,
          regimeSocial: Number.parseInt(this.personne.conjointRegimeSociale),
          isRegimeSocialDifferent: false,
          isDisabled: false,
        },
        enfants: [],
      };

      this.quotationForm = {
        assureInfos: this.infos,
        assurePrincipal: this.assure,
        family: this.family,
        universBesoinInfo: {
          hasAlreadyHealthContract: false,
          healthContractName: 'Axa',
          monthlyBudget: 1,
          formula: 200,
          questions: this.universBesoinQuestionResponse,
        },
        vadInfo: {
          isVad: true,
          saleType: 1,
          isCallFromProspect: false,
          isRappel: this.personne.etre_contacte_par_telephone,
          isBloctel: false,
          toggleBloctel: false,
          toggleVad: false,
          signatureReadyDate: '2022-10-09',
        },
      };
      this.defaultBrokerFees = {
        type: 1,
        healthRateLinear: 10,
        healthRateWithholding: 1,
        loading: 1,
        management: 1,
      };

      this.quotationParamOrigin =
        this.healthInsuranceService.getStoredData().quotationParamOrigin;
      this.quotationCodeOrigin =
        this.healthInsuranceService.getStoredData().quotationCodeOrigin;
      this.quotationCodeParrain =
        this.healthInsuranceService.getStoredData().quotationCodeParrain;
      this.quotationBaseOrigin =
        this.healthInsuranceService.getStoredData().quotationBaseOrigin;
      this.quotationAcceptCompMT =
        this.healthInsuranceService.getStoredData().quotationAcceptCompMT;
      this.quotationNavigator =
        this.healthInsuranceService.getStoredData().quotationNavigator;
      const dataStoredQuotation: HealthModels.HealthQuotationStoredData = {
        quotationForm: this.quotationForm,
        brokerFees: this.defaultBrokerFees,
        controlListeParam:
          this.healthInsuranceService.getStoredData().controlListeParam,
        quotationParamOrigin: this.quotationParamOrigin,
        quotationCodeOrigin: this.quotationCodeOrigin,
        quotationCodeParrain: this.quotationCodeParrain,
        quotationBaseOrigin: this.quotationBaseOrigin,
        quotationAcceptCompMT: this.quotationAcceptCompMT,
        formulaChoice:
          this.healthInsuranceService.getStoredData().formulaChoice,
        currentStaggering: 1,
        package: this.healthInsuranceService.packageId,
        quotationNavigator: this.healthInsuranceService.getInfoNavigator(),
      };
      const storedData = {
        ...dataStoredQuotation,
        quotationForm: {
          ...dataStoredQuotation.quotationForm,
        },
        formulaChoice: {
          ...dataStoredQuotation.formulaChoice,
        },
        brokerFees: {
          ...dataStoredQuotation.brokerFees,
        },
        package: dataStoredQuotation.package,
      } as HealthModels.HealthQuotationStoredData;

      this.healthInsuranceService.setData(storedData);

      this.defaultcontrolListeParam =
        this.healthInsuranceService.getStoredData().controlListeParam;
      this.defaultFormulaChoice =
        this.healthInsuranceService.getStoredData().formulaChoice;
      this.currentStaggering = 1;
      this.package = this.storedData.package;
    }
  }

  getBullesNiveau(nv: string) {
    switch (nv) {
      case '1':
        return 1;
      case '2':
        return 2;
      case '3':
        return 3;
      case '4':
        return 4;
      default:
        return 0;
    }
  }

  replaceFormule(f: string, tarif: string) {
    if (tarif == 'ZEN_SANTE_SENIOR' || tarif == 'ZEN_SANTE_SENIOR_ECO') {
      if (f == 'MO-11-10-10') {
        return 'Formule HOSPI';
      } else {
        f = f.split('-', 4)[2];
        f = f.substring(0, 1);
        return 'Formule ' + (Number(f) - 1);
      }
    }
    if (
      tarif == 'ZEN_SANTE_FOCUS_FAMILLE' ||
      tarif == 'ZEN_SANTE_FOCUS_55_PLUS'
    ) {
      f = f.split('-', 4)[2];
      f = f.substring(0, 1);
      var formuleCode = Math.floor((Number(f) + 1) / 2);
      return (
        'Formule ' + formuleCode + (Number(f) % 2 == 0 ? ' Renforcée' : '')
      );
    }
    if (
      tarif == 'CEGEMA_FLEXI_SANTE_RESPONSABLE' ||
      tarif == 'CEGEMA_FLEXI_SANTE_NON_RESPONSABLE'
    ) {
      f = f.substring(1, f.length);
      return 'Formule ' + f;
    }
    if (tarif == 'KEREIS_SERENITE') {
      f = f.substring(1, f.length);
      return 'Formule ' + f;
    }
    if (tarif == 'SPVIE_GENIUS_ESSENTIELLE') {
      return 'Formule ' + f;
    }
    if (tarif == 'ZEN_SANTE_55_PLUS' || tarif == 'ZEN_SANTE_FAMILLE') {
      f = f.split('-', 4)[2];
      f = f.substring(0, 1);
      return 'Formule ' + f;
    } else {
      if (tarif == 'PROGR_SANTE_FAMILLE' || tarif == 'PROGR_SANTE_SENIOR') {
        return f;
      } else {
        let a = Array.from(f.trim());
        return 'Formule ' + a[a.length - 1];
      }
    }
  }

  tagDevis(
    produit: QuotationModels.ReponseAfiExport,
    tarif: QuotationModels.Tarif | any,
    index: number,
    buttonNom: string,
  ) {
    let age = this.calcAge(this.personne.dateNaissanceAssure);
    if (window['tC']) {
      let compagnie = '';

      if (
        tarif.produitTarif == 'CEGEMAEss' ||
        tarif.produitTarif == 'CEGEMAV' ||
        tarif.produitTarif == 'CEGE_EQUILIBRE' ||
        tarif.produitTarif == 'CEGEMA_FLEXI_SANTE_NON_RESPONSABLE' ||
        tarif.produitTarif == 'CEGEMA_FLEXI_SANTE_RESPONSABLE' ||
        tarif.produitTarif == 'KEREIS_SERENITE'
      ) {
        compagnie = 'CEGEMA';
      }
      if (tarif.produitTarif == 'VITAMIN3') {
        compagnie = 'APIVIA';
      }
      if (
        tarif.produitTarif == 'SWLF_RETRAITES' ||
        tarif.produitTarif == 'PARTICULIER'
      ) {
        compagnie = 'SWISS LIFE';
      }
      if (
        tarif.produitTarif == 'ZEN_SANTE_FAMILLE' ||
        tarif.produitTarif == 'ZEN_SANTE_55_PLUS'
      ) {
        compagnie = 'ZENIOO';
      } else if (
        tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE_ECO' ||
        tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE' ||
        tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR_ECO' ||
        tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR' ||
        tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR_ECO' ||
        tarif.produitTarif == 'AESIO_IMM_SANTE_FAMILLE' ||
        tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR_ECO' ||
        tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR' ||
        tarif.produitTarif == 'RELAXEO2' ||
        tarif.produitTarif == 'ESS_SANTE_FAMILLE' ||
        tarif.produitTarif == 'ESS_SANTE_SENIOR' ||
        tarif.produitTarif == 'AC_PRIVILEGE' ||
        tarif.produitTarif == 'ESSENTIEL_PLUS_SANTE' ||
        tarif.produitTarif == 'ESSENTIEL_PLUS_SANTE_ECO'
      ) {
        compagnie = 'MEILLEURSTAUX SANTE';
      }

      let datatc: any = {
        event_id: 'clic',
        event_categorie: 'clic',
        event_nom: buttonNom,
        event_clic_detail_1: 'cta',
        event_clic_detail_2: 'bloc resultat',
        event_clic_detail_3: compagnie,
        event_clic_detail_4: tarif.produitTarif,
        event_clic_detail_5: this.replaceFormule(
          tarif.codeFormule,
          tarif.produitTarif,
        ),
        event_clic_detail_6: index + 1,
        event_clic_detail_7: this.ate(tarif.montant).toFixed(2),
      };

      if (age >= 0) {
        datatc['event_user_age'] = age + '';
        if (window['tc_vars']) window['tc_vars']['event_user_age'] = age + '';
      }

      window['tC'].event.clic(this, datatc);

      // window["tC"].event.action(this,{
      //   'event_id': 'action',
      //   'event_categorie': 'affichage pop-in',
      //   'event_nom': 'demandez un devis',
      //   'event_clic_detail_1': compagnie,
      //   'event_clic_detail_2': tarif.produitTarif,
      //   'event_clic_detail_3': this.replaceFormule(tarif.codeFormule),
      //   'event_clic_detail_4': index + 1,
      //   'event_clic_detail_5': this.ate(tarif.montant).toFixed(2)
      // });
    }
  }
  tagSouscription(
    produit: QuotationModels.ReponseAfiExport,
    tarif: QuotationModels.Tarif | any,
    index: number,
    buttonNom: string,
  ) {
    let age = this.calcAge(this.personne.dateNaissanceAssure);
    if (window['tC']) {
      let compagnie = '';

      if (
        tarif.produitTarif == 'CEGEMAEss' ||
        tarif.produitTarif == 'CEGEMAV' ||
        tarif.produitTarif == 'CEGE_EQUILIBRE' ||
        tarif.produitTarif == 'CEGEMA_FLEXI_SANTE_NON_RESPONSABLE' ||
        tarif.produitTarif == 'CEGEMA_FLEXI_SANTE_RESPONSABLE' ||
        tarif.produitTarif == 'KEREIS_SERENITE'
      ) {
        compagnie = 'CEGEMA';
      }
      if (tarif.produitTarif == 'VITAMIN3') {
        compagnie = 'APRIVIA';
      }
      if (
        tarif.produitTarif == 'PARTICULIER' ||
        tarif.produitTarif == 'SWLF_RETRAITES'
      ) {
        compagnie = 'SWISS LIFE';
      }
      if (
        tarif.produitTarif == 'ZEN_SANTE_FAMILLE' ||
        tarif.produitTarif == 'ZEN_SANTE_55_PLUS'
      ) {
        compagnie = 'ZENIOO';
      } else if (
        tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE_ECO' ||
        tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE' ||
        tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR_ECO' ||
        tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR' ||
        tarif.produitTarif == 'AESIO_IMM_SANTE_FAMILLE_ECO' ||
        tarif.produitTarif == 'AESIO_IMM_SANTE_FAMILLE' ||
        tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR_ECO' ||
        tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR' ||
        tarif.produitTarif == 'RELAXEO2' ||
        tarif.produitTarif == 'ESS_SANTE_FAMILLE' ||
        tarif.produitTarif == 'ESS_SANTE_SENIOR' ||
        tarif.produitTarif == 'AC_PRIVILEGE' ||
        tarif.produitTarif == 'ESSENTIEL_PLUS_SANTE' ||
        tarif.produitTarif == 'ESSENTIEL_PLUS_SANTE_ECO'
      ) {
        compagnie = 'MEILLEURSTAUX SANTE';
      }
      let datatc: any = {
        event_id: 'clic',
        event_categorie: 'clic',
        event_nom: buttonNom,
        event_clic_detail_1: 'cta',
        event_clic_detail_2: 'bloc resultat',
        event_clic_detail_3: compagnie,
        event_clic_detail_4: tarif.produitTarif,
        event_clic_detail_5: this.replaceFormule(
          tarif.codeFormule,
          tarif.produitTarif,
        ),
        event_clic_detail_6: index + 1,
        event_clic_detail_7: this.ate(tarif.montant).toFixed(2),
      };

      if (age >= 0) {
        datatc['event_user_age'] = age + '';
      }

      window['tC'].event.clic(this, datatc);

      // window["tC"].event.action(this,{
      //   'event_id': 'action',
      //   'event_categorie': 'affichage pop-in',
      //   'event_nom': 'demandez un devis',
      //   'event_clic_detail_1': compagnie,
      //   'event_clic_detail_2': tarif.produitTarif,
      //   'event_clic_detail_3': this.replaceFormule(tarif.codeFormule),
      //   'event_clic_detail_4': index + 1,
      //   'event_clic_detail_5': this.ate(tarif.montant).toFixed(2)
      // });
    }
  }

  calcAge(dateNaissance: string) {
    let a = new Date().getTime();
    const formats = [
      'dd/MM/yyyy',
      'd/MM/yyyy',
      'dd/M/yyyy',
      'd/M/yyyy',
      'yyyy-MM-dd',
      'yyyy-MM-d',
      'yyyy-M-dd',
      'yyyy-M-d',
    ];

    let b: number = NaN;
    for (const format of formats) {
      const dt = DateTime.fromFormat(dateNaissance, format);
      if (dt.isValid) {
        b = dt.toJSDate().getTime();
        break;
      }
    }

    let timeDiff = Math.abs(a - b);
    let age = Math.round(timeDiff / (1000 * 3600 * 24) / 365.25);
    localStorage.setItem('AgeSouscripteur', age.toString());
    return age;
  }
  verifyDateBetween(date1: string, date2: string): boolean {
    let startDate = new Date(date1);
    let endDate = new Date(date2);
    const dateToVerify: Date = new Date();
    const isBetween = dateToVerify >= startDate && dateToVerify <= endDate;
    return isBetween;
  }
  IsAgePlus55(): boolean {
    const agePlus = this.calcAge(this.personne.dateNaissanceAssure);
    if (agePlus >= 55) return true;
    else return false;
  }
  IsAgeMoins55(): boolean {
    const agePlus = this.calcAge(this.personne.dateNaissanceAssure);
    if (agePlus < 55) return true;
    else return false;
  }
  formatProductName(code_gamme: string) {
    switch (code_gamme) {
      case 'ESS_SANTE_SENIOR':
        return 'Essentiel Santé Sénior';
      case 'PREVOIR_IMM_SANTE_SENIOR':
        return 'Immédiat 100% Santé sénior';
      case 'RELAXEO2':
        return 'Relaxeo2';
      case 'CEGEMAEss':
        return 'Cegema Essentiel 2';
      case 'PREVOIR_IMM_SANTE_SENIOR_ECO':
        return 'Immédiat 100% Santé Senior Eco';
      case 'ESSENTIEL_PLUS_SANTE':
        return 'Essentiel Plus Santé';
      case 'ESSENTIEL_PLUS_SANTE_ECO':
        return 'Essentiel Plus Santé Eco';
      default:
        return code_gamme;
    }
  }

  applyStylesAndImages() {
    //mutuelle online
    this.updateDOM(
      'mutuelleonline_affiliation',
      'bodyMutuelleOnlineContainer',
      '#D44B55',
      {
        familleAvatar: 'assets/img/familleAvatar_mutuelle_online.svg',
      },
    );

    //La bonne mutuelle
    this.updateDOM(
      'labonnemutuelle_affiliation',
      'bodyLaBonneMutuelleSubContainer',
      '#84C13D',
      {
        familleAvatar: 'assets/img/familleAvatar_la_bonne_mutuelle.svg',
      },
    );

    //Assurance et mutuelle
    this.updateDOM(
      'assuranceetmutuelle_affiliation',
      'bodyAssuranceEtMutuelleContainer',
      '#6f9a43',
      {
        familleAvatar: 'assets/img/familleAvatar_assurance_et_mutuelle.svg',
      },
    );

    //AFI Sante
    this.updateDOM(
      'afisante_affiliation',
      'bodyAffiliationSubContainer',
      '#0e74a4',
      {
        familleAvatar: 'assets/img/familleAvatar_afi_sante.svg',
      },
    );
  }

  private updateDOM(
    expectedCode: string,
    containerClass: string,
    colorTextNbreFormule: string,
    imgSrcs: {
      familleAvatar?: string;
    },
  ) {
    const parameterCodeOrigin = localStorage.getItem('codeOrigin');
    if (parameterCodeOrigin === expectedCode) {
      this.addClassToContainer(containerClass);
      this.textNombreFormule = colorTextNbreFormule;

      const imgSelectors: any = {
        familleAvatar: `#avatarDiv img`,
      };

      for (const [key, src] of Object.entries(imgSrcs)) {
        if (src) {
          this.updateImageSource(
            `.${containerClass} ${imgSelectors[key]}`,
            src,
          );
        }
      }
    }
  }

  private addClassToContainer(containerClass: string) {
    const container = document.querySelector('.containerTarif') as HTMLElement;
    if (container) {
      container.classList.add(containerClass);
    }
  }

  private updateImageSource(selector: string, src: string) {
    const imgElements = document.querySelectorAll<HTMLImageElement>(selector);
    imgElements.forEach((img) => {
      if (img.getAttribute('src') !== src) {
        img.src = src;
      }
    });
  }

  IsNoDisplayButton(typeproduit: string): boolean {
    var mtxSanteani = this.produitsMtxSanteAni.includes(typeproduit);
    var ageAni = this.IsAgeMoins55();
    if (mtxSanteani && ageAni) {
      this.templateDisplay = true;
      return true;
    } else return false;
  }
  IsButtonOrange(typeproduit: string): boolean {
    var mtxSanteani = this.produitsMtxSanteAni.includes(typeproduit);
    if (mtxSanteani) {
      this.pathImg = 'assets/img/edit-white.svg';
      return true;
    } else {
      this.pathImg = 'assets/img/edit.svg';
      return false;
    }
  }
  afficherLogoMTX(typeProduct: string): boolean {
    return this.mtxLogoProduitsTarifs.includes(typeProduct);
  }
  afficherLogoZNIOO(typeProduct: string): boolean {
    return this.zeniooLogoProduitsTarifs.includes(typeProduct);
  }

  GetDocByGammename_old(gammeName: string, docName: string): void {
    const newTab = window.open('', '_blank'); // Ouvre l'onglet immédiatement

    if (newTab) {
      newTab.document.write(`
      <html>
        <head>
          <title>Chargement du document...</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
              margin: 0;
              background-color: #ffffffff;
            }
            .message {
              text-align: center;
            }
          </style>
        </head>
        <body>
          <div class="message">
            <h2>Chargement du document PDF...</h2>
            <p>Veuillez patienter quelques instants.</p>
          </div>
        </body>
      </html>
    `);
    }

    this.fileService
      .downloadDocByGammeName(gammeName, docName)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: HttpModels.HttpFileResponse) => {
          const blob = new Blob([res.blob], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);

          if (newTab) {
            newTab.location.href = blobUrl;
          }
        },
        error: (error) => {
          console.error('Erreur lors du téléchargement du document :', error);
          if (newTab) {
            newTab.document.body.innerHTML = `
            <h2>Erreur lors du chargement du document.</h2>
            <p>Veuillez réessayer plus tard.</p>
          `;
          }
        },
      });
  }

  GetDocByGammename(gammeName: string, docName: string): void {
    const newTab = this.documentTabService.openLoadingTab();

    this.fileService
      .downloadDocByGammeName(gammeName, docName)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: HttpModels.HttpFileResponse) => {
          const blob = new Blob([res.blob], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
          this.documentTabService.redirectToBlob(newTab, blobUrl);
        },
        error: (error) => {
          console.error('Erreur lors du téléchargement du document :', error);
          this.documentTabService.showError(newTab);
        },
      });
  }
}
